import { Component, OnInit, ElementRef, NgZone, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Configuration } from '../../config/config';
import { AuthService } from '../../Services/AuthGard.service';
import { UserService } from '../../Services/Users.service';
import { GlobalService } from '../../Services/global.service';
import { licence } from '../../models/licence';
import { LicenseService } from "../../Services/license.service";
import { Http, Response } from '@angular/http';
import { User } from '../../models/Users';
import { changePwd } from '../../models/changePwd';
import { parse, isValidNumber, formatNumber } from 'libphonenumber-js';
import { NgForm } from "@angular/forms";
import * as CryptoJS from 'crypto-js';
import Player from "@vimeo/player";
import { CookieService } from 'ngx-cookie-service';
import { DomSanitizer } from '@angular/platform-browser';
declare var $;
declare var Tour: any;
declare let paypal: any;

class Support {
  constructor(
    public question?: string,
    public answer?: string,
    public user_id?: string,
    public fullname?: string,
    public username?: string,
    public comm_id?: string
  ) { }
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [LicenseService]
})
export class HeaderComponent implements OnInit {

  @ViewChild('subscriptionForm') subscriptionForm: NgForm;
  @ViewChild('subscriptionFormL') subscriptionFormL: NgForm;
  @ViewChild('passForm') passForm: NgForm;
  @ViewChild('supportForm') supportForm: NgForm;
  @ViewChild('animatedVideo') animatedVideo;
  @ViewChild('vimeoVideo') vimeoVideo;

  User: User = new User();
  langList: Array<any> = [];
  data: any;
  lang_name: any;
  lang_id: any;
  showMessages = [];
  fullname: string;
  noMessage: boolean = true;
  noNotification: boolean = true;
  getMessageCount: string;
  getNotificationCount: number;
  license = new licence();
  selectedLicensesList: any[] = [];
  validationMsg: string = "";
  coupon_code;
  TotalPrice = 0;
  InvalidCoupon = false;
  subtotal = 0;
  valArr = [];
  paymentBy;
  Payments;
  selectedMessage;
  subscribeLicIdList = [];
  noofLicenses = 1;
  licence_name;
  duration;
  paidStatus;
  price;
  term;
  licence_id;
  licence_user_id;
  community_name: string;
  msg_content: string;
  password: string;
  imagedata;
  communityLogoShow: boolean;
  showIntroVideo: boolean = false;
  localVideo: boolean = false;
  onlineVideo: boolean = false;
  videoSource: any;
  videoSrtPath: any;
  videoEngSrtPath: any;
  youtubePlayerFlag: boolean = true;
  vimeoPlayerFlag: boolean = true;
  player: YT.Player;
  vimeoPlayer: Player;
  options = {};
  couponValidationMsg: string = "";
  appliedCoupons = 0;
  coupon_id;
  selectedMsgId;
  notificationList: Array<any> = [];
  isCommunityActive;
  image_data;
  files: File;
  fileCode: boolean = false;
  user_profile_pic;
  proPicStatusCode: string = "";
  selected_courses = [];
  selected_certificates = [];
  selected_journeys = [];
  isFirstLogin: boolean = true;
  title = 'Alignor project';
  countryCodeList: any;
  parse: any;
  errorMsg: string = "";
  userUpdateStatusCode: string = "";
  comm_privacy_protect: boolean;
  fileUpload: string;
  tour: any;
  licenseRenewStatusCode: string = '';
  tourTranslateData: any;
  profileTranslateData: any;
  discountPrice: number = 0;

  changePwdObj = new changePwd();
  pwdErrorCode: string;
  getRole;
  displayRole;
  agreement: any;
  gamesTotalScore: number;

  globalCommRoleList: Array<any> = [];
  globalBUnitList: Array<any> = [];
  communityRoleList: Array<any> = [];
  businessUnitList: Array<any> = [];
  comm_role = undefined;
  business_unit = undefined;
  isDisableBUnit: boolean = false;
  isDisableCommRole: boolean = false;
  community_id: string = '';
  countryCode: string = undefined;
  countryId: string = undefined;
  screenWidth: number = 1366;
  screenHeight: number;
  supportObj = new Support();
  suportSuccessMsg: boolean;
  supportQueData: any;
  user1: string;

  questionArr: any;
  SUPPORT: any;
  passwordType: boolean = false;
  passwordNewType: boolean = false;
  passwordConfirmType: boolean = false;

  securityQuestions: Array<any> = [];
  que_id: string;
  userId: string;
  question: string;
  answer: string;
  authenticationType: string;
  securityQueSuccessCode: string;
  Typechecking: string;
  fname: any;
  lname: any;
  hello: string;
  user2: any;
  coachUrl: any;
  iframeHeight: string;
  iframeWidth: string;
  coachingModalPopupHeight: string;
  coachingModalPopupWidth: string;
  subscribeUrl: any;
  openSubscriptionModal: boolean = false;

  constructor(private router: Router,
    private AuthService: AuthService,
    private translate: TranslateService,
    private GlobalService: GlobalService,
    private userService: UserService,
    private LicenseService: LicenseService,
    private http: Http,
    private cookieService: CookieService,
    private activatedRoute:ActivatedRoute,
    public sanitizer: DomSanitizer,
    private el: ElementRef) {

    this.countryCodeList = Configuration.countryCode;
    let defaultLangData;
    const theUser = JSON.parse(localStorage.getItem('currentUser'));
    this.userId = theUser.user.userid;
    try {
      defaultLangData = JSON.parse(this.cookieService.get('defaultLangData'));

    } catch (exp) {
      console.log(exp)
    }
    console.log("------------------- Cookie Lang-----------------------");
    console.log(defaultLangData);
    /* code for taking language from db*/
    // if (defaultLangData) {
    //   this.lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : "English";
    //   this.lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : "English";
    // } else if (theUser && theUser.user && theUser.user.defaultLang) {
    //   this.lang_name = theUser.user.defaultLang;
    //   this.lang_id = theUser.user.language_id;
    // } else {
    //   this.lang_name = "English";
    //   this.lang_id = "English";
    // }
    /* code for taking language from db*/

    /* code for taking language from cookie start*/
    if (defaultLangData) {
      this.lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : "English";
      this.lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : "English";
    } else if (theUser && theUser.user && theUser.user.defaultLang) {
      this.lang_name = theUser.user.defaultLang;
      this.lang_id = theUser.user.language_id;
    } else {
      this.lang_name = "English";
      this.lang_id = "English";
    }
    /* code for taking language from cookie end*/

    const role = localStorage.getItem('userRole');
    this.getRole = role;
    if (this.getRole == "Alignor Admin" || this.getRole == "Game Author" || this.getRole == "Translator") {
      this.lang_name = 'English';
      this.lang_id = "English";
      this.GlobalService.setLang(this.lang_name);
      this.GlobalService.setLangId(this.lang_id);

      localStorage.setItem('defaultLangId', this.lang_id);
      localStorage.setItem('defaultLang', this.lang_name);

      this.translate.use(this.lang_name);

      let customObject = {
        lang_id: this.lang_id,
        lang_name: this.lang_name
      };
      let jsonString = JSON.stringify(customObject);
      this.cookieService.set('defaultLangData', jsonString, 365, '/');
      console.log("------------------- After Lang Set -----------------------");
      console.log(document.cookie);

      this.GlobalService.getTranslationTour();
      this.GlobalService.getTableLanguage();
      /*code for taking language from cookie end*/
      this.translate.get(['TOUR_PREV', 'TOUR_NEXT', 'TOUR_END', 'MENU.LEARN', 'MENU.SCORECARD', 'MENU.TENDENCY', 'MENU.LEADER_BOARD', 'SETTING', 'MENU.SUBSCRIPTION', 'UPDATE_PROFILE', 'HELP', 'LOGOUT', "MENU.LEADER_BOARD", "CHANGE_PWD", 'NOTIFICATION.NOTIFICATION', 'TOTAL_SCORE', 'SUBSCRIPTION_FORM.AMOUNT_PAID', 'SUBSCRIPTION_FORM.TRANSACTION_SUCCESS', 'SUBSCRIPTION_FORM.TRANSACTION_ID',
        'CHANGE_PWD', 'REGISTRATION.OLD_PASSWORD', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'NEWPASSWORD', 'REGISTRATION.PASSWORD_NOTE', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'CONFORMPASSWORD', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'REGISTRATION.VALIDATION_MSG.INVALID_CONFORM_PASSWORD',
        'BATCH_LIST.SERVER_VALIDATION_MSG.USER_NOT_FOUND', 'REGISTRATION.VALIDATION_MSG.OLD_PASS_NOT_MATCH', 'BUTTON_TITLE.CANCEL', 'BUTTON_TITLE.UPDATE', 'TOOLTIPS.SIGN_OUT', 'TOOLTIPS.CHANGE_PWD', 'TOOLTIPS.SECURITY_QUE', 'SECURITY_QUE', 'TOOLTIPS.UPDATE_PROFILE', 'TOOLTIPS.SUBSCRIPTION', 'TOOLTIPS.SETTING', 'TOOLTIPS.HELP', 'TOOLTIPS.MESSAGE', 'TOOLTIPS.NOTIFICATION']).subscribe(label => {
          console.log("-----------------Header Label-------------------");
          this.tourTranslateData = label;
        });
      this.translate.get(['UPDATE_PROFILE', 'REGISTRATION.USER_ID', 'REGISTRATION.USER_ID', 'REGISTRATION.VALIDATION_MSG.REQUIRED_USERNAME', 'REGISTRATION.VALIDATION_MSG.INVALID_USERNAME', 'REGISTRATION.COMM_ROLE', 'REGISTRATION.SELECT_ROLE', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COMMUNITY_ROLE', 'REGISTRATION.NONE', 'REGISTRATION.BUSINESS_UNIT',
        'REGISTRATION.SELECT_B_UNIT', 'REGISTRATION.VALIDATION_MSG.REQUIRED_BUSINESS_UNIT', 'REGISTRATION.FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_FIRST_NAME', 'REGISTRATION.LAST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_LAST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_LAST_NAME', 'REGISTRATION.EMAIL_ID',
        'REGISTRATION.VALIDATION_MSG.REQUIRED_EMAILID', 'REGISTRATION.VALIDATION_MSG.INVALID_EMAILID', 'REGISTRATION.DESIG', 'REGISTRATION.COUNTRY', 'REGISTRATION.COUNTRY_CODE', 'REGISTRATION.CONTACT_NO', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COUNTRY_CODE', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INVALID_NUMBER', 'REGISTRATION.REGISTER_USER_SERVER_MSG.WRONG_NUMBER',
        'REGISTRATION.VALIDATION_MSG.REQUIRED_CONTACTNO', 'REGISTRATION.ORG', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INCOMPLETE_DATA', 'REGISTRATION.REGISTER_USER_SERVER_MSG.NETWORK_ERROR', 'BUTTON_TITLE.CANCEL', 'BUTTON_TITLE.UPDATE', 'TOOLTIPS.PROFILE_IMAGE'
      ]).subscribe(label => {
        this.profileTranslateData = label;
      })
      this.translate.get('SELECT_PROFILE_PIC').subscribe(label => {
        this.fileUpload = label;
      });
      this.translate.get('SUPPORT_QUESTIONS').subscribe(label => {
        this.questionArr = label;
      });
      this.translate.get('SUPPORT').subscribe(label => {
        this.SUPPORT = label;
      });
    }

    /* code for taking language from db*/
    // if (this.lang_name == "English") {
    //   this.userService.getSelectedLanguageLearner(theUser.user.userid)
    //     .subscribe(user => {
    //       console.log(user, "----user----");
    //       this.lang_name = user.data.defaultLang;
    //       this.lang_id = user.data.language_id;

    //       this.GlobalService.setLang(this.lang_name);
    //       this.GlobalService.setLangId(this.lang_id);

    //       localStorage.setItem('defaultLangId', this.lang_id);
    //       localStorage.setItem('defaultLang', this.lang_name);

    //       this.translate.use(this.lang_name);

    //       let customObject = {
    //         lang_id: this.lang_id,
    //         lang_name: this.lang_name
    //       };
    //       let jsonString = JSON.stringify(customObject);
    //       this.cookieService.set('defaultLangData', jsonString, 365, '/');
    //       this.translate.get(['TOUR_PREV', 'TOUR_NEXT', 'TOUR_END', 'MENU.LEARN', 'MENU.SCORECARD', 'MENU.TENDENCY', 'MENU.LEADER_BOARD', 'SETTING', 'MENU.SUBSCRIPTION', 'UPDATE_PROFILE', 'HELP', 'LOGOUT', "MENU.LEADER_BOARD", "CHANGE_PWD", 'NOTIFICATION.NOTIFICATION', 'TOTAL_SCORE', 'SUBSCRIPTION_FORM.AMOUNT_PAID', 'SUBSCRIPTION_FORM.TRANSACTION_SUCCESS', 'SUBSCRIPTION_FORM.TRANSACTION_ID',
    //         'CHANGE_PWD', 'REGISTRATION.OLD_PASSWORD', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'NEWPASSWORD', 'REGISTRATION.PASSWORD_NOTE', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'CONFORMPASSWORD', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'REGISTRATION.VALIDATION_MSG.INVALID_CONFORM_PASSWORD',
    //         'BATCH_LIST.SERVER_VALIDATION_MSG.USER_NOT_FOUND', 'REGISTRATION.VALIDATION_MSG.OLD_PASS_NOT_MATCH', 'BUTTON_TITLE.CANCEL', 'BUTTON_TITLE.UPDATE', 'TOOLTIPS.SIGN_OUT', 'TOOLTIPS.CHANGE_PWD', 'TOOLTIPS.SECURITY_QUE', 'SECURITY_QUE', 'TOOLTIPS.UPDATE_PROFILE', 'TOOLTIPS.SUBSCRIPTION', 'TOOLTIPS.SETTING', 'TOOLTIPS.HELP', 'TOOLTIPS.MESSAGE', 'TOOLTIPS.NOTIFICATION']).subscribe(label => {
    //           console.log("-----------------Header Label-------------------");
    //           this.tourTranslateData = label;
    //         });
    //       this.translate.get(['UPDATE_PROFILE', 'REGISTRATION.USER_ID', 'REGISTRATION.USER_ID', 'REGISTRATION.VALIDATION_MSG.REQUIRED_USERNAME', 'REGISTRATION.VALIDATION_MSG.INVALID_USERNAME', 'REGISTRATION.COMM_ROLE', 'REGISTRATION.SELECT_ROLE', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COMMUNITY_ROLE', 'REGISTRATION.NONE', 'REGISTRATION.BUSINESS_UNIT',
    //         'REGISTRATION.SELECT_B_UNIT', 'REGISTRATION.VALIDATION_MSG.REQUIRED_BUSINESS_UNIT', 'REGISTRATION.FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_FIRST_NAME', 'REGISTRATION.LAST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_LAST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_LAST_NAME', 'REGISTRATION.EMAIL_ID',
    //         'REGISTRATION.VALIDATION_MSG.REQUIRED_EMAILID', 'REGISTRATION.VALIDATION_MSG.INVALID_EMAILID', 'REGISTRATION.DESIG', 'REGISTRATION.COUNTRY', 'REGISTRATION.COUNTRY_CODE', 'REGISTRATION.CONTACT_NO', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COUNTRY_CODE', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INVALID_NUMBER', 'REGISTRATION.REGISTER_USER_SERVER_MSG.WRONG_NUMBER',
    //         'REGISTRATION.VALIDATION_MSG.REQUIRED_CONTACTNO', 'REGISTRATION.ORG', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INCOMPLETE_DATA', 'REGISTRATION.REGISTER_USER_SERVER_MSG.NETWORK_ERROR', 'BUTTON_TITLE.CANCEL', 'BUTTON_TITLE.UPDATE', 'TOOLTIPS.PROFILE_IMAGE'
    //       ]).subscribe(label => {
    //         this.profileTranslateData = label;
    //       })
    //       this.translate.get('SELECT_PROFILE_PIC').subscribe(label => {
    //         this.fileUpload = label;
    //       });
    //       this.translate.get('SUPPORT_QUESTIONS').subscribe(label => {
    //         this.questionArr = label;
    //       });
    //       this.translate.get('SUPPORT').subscribe(label => {
    //         this.SUPPORT = label;
    //       });

    //     });
    // } else {
    //   this.GlobalService.setLang(this.lang_name);
    //   this.GlobalService.setLangId(this.lang_id);

    //   localStorage.setItem('defaultLangId', this.lang_id);
    //   localStorage.setItem('defaultLang', this.lang_name);

    //   this.translate.use(this.lang_name);

    //   let customObject = {
    //     lang_id: this.lang_id,
    //     lang_name: this.lang_name
    //   };
    //   let jsonString = JSON.stringify(customObject);
    //   this.cookieService.set('defaultLangData', jsonString, 365, '/');
    //   console.log("------------------- After Lang Set -----------------------");
    //   console.log(document.cookie);

    //   this.GlobalService.getTranslationTour();
    //   this.GlobalService.getTableLanguage();
    //   /*code for taking language from cookie end*/
    //   this.translate.get(['TOUR_PREV', 'TOUR_NEXT', 'TOUR_END', 'MENU.LEARN', 'MENU.SCORECARD', 'MENU.TENDENCY', 'MENU.LEADER_BOARD', 'SETTING', 'MENU.SUBSCRIPTION', 'UPDATE_PROFILE', 'HELP', 'LOGOUT', "MENU.LEADER_BOARD", "CHANGE_PWD", 'NOTIFICATION.NOTIFICATION', 'TOTAL_SCORE', 'SUBSCRIPTION_FORM.AMOUNT_PAID', 'SUBSCRIPTION_FORM.TRANSACTION_SUCCESS', 'SUBSCRIPTION_FORM.TRANSACTION_ID',
    //     'CHANGE_PWD', 'REGISTRATION.OLD_PASSWORD', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'NEWPASSWORD', 'REGISTRATION.PASSWORD_NOTE', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'CONFORMPASSWORD', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'REGISTRATION.VALIDATION_MSG.INVALID_CONFORM_PASSWORD',
    //     'BATCH_LIST.SERVER_VALIDATION_MSG.USER_NOT_FOUND', 'REGISTRATION.VALIDATION_MSG.OLD_PASS_NOT_MATCH', 'BUTTON_TITLE.CANCEL', 'BUTTON_TITLE.UPDATE', 'TOOLTIPS.SIGN_OUT', 'TOOLTIPS.CHANGE_PWD', 'TOOLTIPS.SECURITY_QUE', 'SECURITY_QUE', 'TOOLTIPS.UPDATE_PROFILE', 'TOOLTIPS.SUBSCRIPTION', 'TOOLTIPS.SETTING', 'TOOLTIPS.HELP', 'TOOLTIPS.MESSAGE', 'TOOLTIPS.NOTIFICATION']).subscribe(label => {
    //       console.log("-----------------Header Label-------------------");
    //       this.tourTranslateData = label;
    //     });
    //   this.translate.get(['UPDATE_PROFILE', 'REGISTRATION.USER_ID', 'REGISTRATION.USER_ID', 'REGISTRATION.VALIDATION_MSG.REQUIRED_USERNAME', 'REGISTRATION.VALIDATION_MSG.INVALID_USERNAME', 'REGISTRATION.COMM_ROLE', 'REGISTRATION.SELECT_ROLE', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COMMUNITY_ROLE', 'REGISTRATION.NONE', 'REGISTRATION.BUSINESS_UNIT',
    //     'REGISTRATION.SELECT_B_UNIT', 'REGISTRATION.VALIDATION_MSG.REQUIRED_BUSINESS_UNIT', 'REGISTRATION.FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_FIRST_NAME', 'REGISTRATION.LAST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_LAST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_LAST_NAME', 'REGISTRATION.EMAIL_ID',
    //     'REGISTRATION.VALIDATION_MSG.REQUIRED_EMAILID', 'REGISTRATION.VALIDATION_MSG.INVALID_EMAILID', 'REGISTRATION.DESIG', 'REGISTRATION.COUNTRY', 'REGISTRATION.COUNTRY_CODE', 'REGISTRATION.CONTACT_NO', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COUNTRY_CODE', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INVALID_NUMBER', 'REGISTRATION.REGISTER_USER_SERVER_MSG.WRONG_NUMBER',
    //     'REGISTRATION.VALIDATION_MSG.REQUIRED_CONTACTNO', 'REGISTRATION.ORG', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INCOMPLETE_DATA', 'REGISTRATION.REGISTER_USER_SERVER_MSG.NETWORK_ERROR', 'BUTTON_TITLE.CANCEL', 'BUTTON_TITLE.UPDATE', 'TOOLTIPS.PROFILE_IMAGE'
    //   ]).subscribe(label => {
    //     this.profileTranslateData = label;
    //   })
    //   this.translate.get('SELECT_PROFILE_PIC').subscribe(label => {
    //     this.fileUpload = label;
    //   });
    //   this.translate.get('SUPPORT_QUESTIONS').subscribe(label => {
    //     this.questionArr = label;
    //   });
    //   this.translate.get('SUPPORT').subscribe(label => {
    //     this.SUPPORT = label;
    //   });
    // }

    /*code for taking language from db end*/

    // code for taking language from cookie
    this.GlobalService.setLang(this.lang_name);
    this.GlobalService.setLangId(this.lang_id);

    localStorage.setItem('defaultLangId', this.lang_id);
    localStorage.setItem('defaultLang', this.lang_name);

    this.translate.use(this.lang_name);

    let customObject = {
      lang_id: this.lang_id,
      lang_name: this.lang_name
    };
    let jsonString = JSON.stringify(customObject);
    this.cookieService.set('defaultLangData', jsonString, 365, '/');
    console.log("------------------- After Lang Set -----------------------");
    console.log(document.cookie);

    this.GlobalService.getTranslationTour();
    this.GlobalService.getTableLanguage();
    //code for taking language from cookie end*/
    this.translate.get(['TOUR_PREV', 'TOUR_NEXT', 'TOUR_END', 'MENU.LEARN', 'MENU.SCORECARD', 'MENU.TENDENCY', 'MENU.LEADER_BOARD', 'SETTING', 'MENU.SUBSCRIPTION', 'UPDATE_PROFILE', 'HELP', 'LOGOUT', "MENU.LEADER_BOARD", "CHANGE_PWD", 'NOTIFICATION.NOTIFICATION', 'TOTAL_SCORE', 'SUBSCRIPTION_FORM.AMOUNT_PAID', 'SUBSCRIPTION_FORM.TRANSACTION_SUCCESS', 'SUBSCRIPTION_FORM.TRANSACTION_ID',
      'CHANGE_PWD', 'REGISTRATION.OLD_PASSWORD', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'NEWPASSWORD', 'REGISTRATION.PASSWORD_NOTE', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'CONFORMPASSWORD', 'REGISTRATION.VALIDATION_MSG.PWD_REQ', 'REGISTRATION.VALIDATION_MSG.INVALID_PASSWORD', 'REGISTRATION.VALIDATION_MSG.INVALID_CONFORM_PASSWORD',
      'BATCH_LIST.SERVER_VALIDATION_MSG.USER_NOT_FOUND', 'REGISTRATION.VALIDATION_MSG.OLD_PASS_NOT_MATCH', 'BUTTON_TITLE.CANCEL', 'BUTTON_TITLE.UPDATE', 'TOOLTIPS.SIGN_OUT', 'TOOLTIPS.CHANGE_PWD', 'TOOLTIPS.SECURITY_QUE', 'SECURITY_QUE', 'TOOLTIPS.UPDATE_PROFILE', 'TOOLTIPS.SUBSCRIPTION', 'TOOLTIPS.SETTING', 'TOOLTIPS.HELP', 'TOOLTIPS.MESSAGE', 'TOOLTIPS.NOTIFICATION']).subscribe(label => {
        console.log("-----------------Header Label-------------------");
        this.tourTranslateData = label;
      });
    this.translate.get(['UPDATE_PROFILE', 'REGISTRATION.USER_ID', 'REGISTRATION.USER_ID', 'REGISTRATION.VALIDATION_MSG.REQUIRED_USERNAME', 'REGISTRATION.VALIDATION_MSG.INVALID_USERNAME', 'REGISTRATION.COMM_ROLE', 'REGISTRATION.SELECT_ROLE', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COMMUNITY_ROLE', 'REGISTRATION.NONE', 'REGISTRATION.BUSINESS_UNIT',
      'REGISTRATION.SELECT_B_UNIT', 'REGISTRATION.VALIDATION_MSG.REQUIRED_BUSINESS_UNIT', 'REGISTRATION.FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_FIRST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_FIRST_NAME', 'REGISTRATION.LAST_NAME', 'REGISTRATION.VALIDATION_MSG.REQUIRED_LAST_NAME', 'REGISTRATION.VALIDATION_MSG.INVALID_LAST_NAME', 'REGISTRATION.EMAIL_ID',
      'REGISTRATION.VALIDATION_MSG.REQUIRED_EMAILID', 'REGISTRATION.VALIDATION_MSG.INVALID_EMAILID', 'REGISTRATION.DESIG', 'REGISTRATION.COUNTRY', 'REGISTRATION.COUNTRY_CODE', 'REGISTRATION.CONTACT_NO', 'REGISTRATION.VALIDATION_MSG.REQUIRED_COUNTRY_CODE', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INVALID_NUMBER', 'REGISTRATION.REGISTER_USER_SERVER_MSG.WRONG_NUMBER',
      'REGISTRATION.VALIDATION_MSG.REQUIRED_CONTACTNO', 'REGISTRATION.ORG', 'REGISTRATION.REGISTER_USER_SERVER_MSG.INCOMPLETE_DATA', 'REGISTRATION.REGISTER_USER_SERVER_MSG.NETWORK_ERROR', 'BUTTON_TITLE.CANCEL', 'BUTTON_TITLE.UPDATE', 'TOOLTIPS.PROFILE_IMAGE'
    ]).subscribe(label => {
      this.profileTranslateData = label;
    })
    this.translate.get('SELECT_PROFILE_PIC').subscribe(label => {
      this.fileUpload = label;
    });
    this.translate.get('SUPPORT_QUESTIONS').subscribe(label => {
      this.questionArr = label;
    });
    this.translate.get('SUPPORT').subscribe(label => {
      this.SUPPORT = label;
    });

    this.userService.getAllLanguage().subscribe(lang => {
      if (lang.success) {
        console.log(lang, "language------------");
        this.langList = lang.data;
        if (this.lang_name != theUser.user.defaultLang) {
          const obj = {
            user_id: theUser.user.userid,
            lang: this.lang_name,
            language_id: this.lang_id
          };
          this.userService.changeLanguage(obj)
            .subscribe(user => {
              theUser.user.defaultLang = this.lang_name;
              localStorage.setItem('currentUser', JSON.stringify(theUser));
            });
        }
      }
    });
  }

  selectName() {
    // alert("changed lang from learner");
    this.cookieService.delete('changeLanguage', '/');
    this.cookieService.delete('defaultLangData');
    let lang = this.langList.find(lang => lang.lang_name == this.lang_name);
    this.lang_id = lang ? lang.language_id : "English";

    console.log("------------------- Before Lang Set -----------------------");
    console.log(this.lang_name);
    console.log(this.lang_id);

    let customObject = {
      lang_id: this.lang_id,
      lang_name: this.lang_name
    };
    let jsonString = JSON.stringify(customObject);
    this.cookieService.set('defaultLangData', jsonString, 365, '/');
    console.log("------------------- After Lang Set -----------------------");
    console.log(document.cookie);

    const user = localStorage.getItem('currentUser');

    if (user) {
      const newUser = JSON.parse(user);
      const obj = {
        user_id: newUser.user.userid,
        lang: this.lang_name,
        language_id: this.lang_id
      };
      const obj1 = {
        user_id: newUser.user.userid,
        language_id: this.lang_id
      };
      this.userService.changeLanguage(obj)
        .subscribe(user => { });

      // this.userService.setSelectedLanguageLearner(obj1)
      //   .subscribe(user => {
      //     console.log(user, "getuser");
      //     // window.location.reload();
      //     this.cookieService.set('defaultLangData', user);
      //     this.translate.reloadLang(lang_name);
      //   });

    }

    window.location.reload();
  };

  ngOnInit() {
    $("#preloader").css('display', 'block');
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;
    // const sessionData = this.activatedRoute.snapshot.queryParams['seesion_id'];
    // alert(sessionData);
    window.addEventListener("orientationchange", () => {
      // Announce the new orientation number
      if (window.orientation == 90) {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      } else {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      }
    });
    this.userService.refreshToken();
    var event = new CustomEvent("Show Header On Login", { "detail": "Example of an event" });
    document.dispatchEvent(event);
    const theUser = JSON.parse(localStorage.getItem('currentUser'));
    let commId1 = theUser.user.community_id;
    if (commId1) {
      this.community_id = commId1;
      this.comm_role = undefined;
      this.business_unit = undefined;
      this.getAllRoleBUnit();
      this.getCommunityResources(commId1);
    }

    if (this.getRole == 'Learner' || this.getRole == 'Manager') {
      this.translate.get('LEARNER_ROLE').subscribe(label => {
        this.displayRole = label;
      });
      $(document).ready(function () {
        $("#disablePreventHeader").on("contextmenu", function () {
          return false;
        });
      });
    } else if (this.getRole == 'Community Admin') {
      this.translate.get('COMM_ADMIN_ROLE').subscribe(label => {
        this.displayRole = label;
      });
    } else {
      this.displayRole = this.getRole;
    }
    if (localStorage.getItem('activationStatus') == "Inactive") {
      this.isCommunityActive = false;
    } else {
      this.isCommunityActive = true;
    }
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log("currentUser data", currentUser);
    this.Typechecking = localStorage.getItem('Typechecking');
    // alert(localStorage.getItem('authenticationType'))

    // this.authenticationType = localStorage.getItem('authenticationType');
    if (localStorage.getItem('authenticationType')) {
      this.authenticationType = this.Typechecking;
      // alert(this.authenticationType);
    } else {
      this.authenticationType = localStorage.getItem('authenticationType');
      // alert(this.authenticationType);
    }

    // console.log(authenticationType,"authenticationType");
    // alert(this.authenticationType)

    if (this.authenticationType != "COGNITO_AUTHENTICATION") {
      if (!currentUser.user.community_user) {
        this.isFirstLogin = true;
      } else {
        this.isFirstLogin = false;
      }
      // alert(this.isFirstLogin);
    }

    // this.userService.cast.subscribe(user1 => {
    //   console.log(user1,"res data for fname lname")
    //   if(user1) this.user2 = user1;
    //   this.fullname = this.user2.fname + " " + this.user2.lname;
    // })


    if (currentUser.user.fullname == undefined || currentUser.user.fullname == " " || currentUser.user.fullname == null) {

      this.fullname = currentUser.user.username;
      console.log("username as fullname", this.fullname)
    }
    else {
      this.fullname = currentUser.user.fullname;
      console.log("Full name is", this.fullname);
    }

    if (currentUser.user.newUser == 'firstTimeLogin' && (currentUser.user.role == 'Learner' || currentUser.user.role == 'Manager')) {
      this.userService.getIntroVideo().subscribe(res => {
        if (res.success) {
          this.showIntroVideo = true;
          $('#animatedVideoModal').modal('show');
          let videoUrl = res.data.url;
          let videoSrt = res.data.video_id;
          if (res.data.type == 'Local') {
            this.localVideo = true;
            this.onlineVideo = false;
            this.videoSource = Configuration.S3_BucketObjectURL + Configuration.S3_VideosPath + videoUrl;
            //this.videoSrtPath = Configuration.Server + 'videos/'+localStorage.getItem('defaultLang') + "/" + videoUrl+'.vtt';
            let lang = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
            this.videoSrtPath = Configuration.S3_BucketObjectURL + Configuration.S3_VideosSrtFilesPath + lang + '/' + videoSrt + '.vtt';//'videos/'+localStorage.getItem('defaultLang') + "/" + video_id+'.vtt';
            this.videoEngSrtPath = Configuration.S3_BucketObjectURL + Configuration.S3_VideosSrtFilesPath + 'English' + '/' + videoSrt + '.vtt';//'videos/'+localStorage.getItem('defaultLang') + "/" + video_id+'.vtt';
          } else if (res.data.type == 'Online') {
            this.localVideo = false;

            if (videoUrl.includes("vimeo")) {
              this.vimeoPlayerFlag = false;
              this.youtubePlayerFlag = true;
              this.videoSource = videoUrl;
              this.options = {
                id: this.videoSource.split("/").pop(),
                width: 760,
                height: 400,
                loop: false
              };
              this.vimeoPlayer = new Player(this.vimeoVideo.nativeElement, this.options);
              // this.vimeoPlayer.pause();
              this.vimeoPlayer.play();
            }
            else if (videoUrl.includes("youtube") || videoUrl.includes("youtu.be")) {
              this.onlineVideo = true;
              this.youtubePlayerFlag = false;
              this.vimeoPlayerFlag = true;
              this.videoSource = videoUrl;
            }
          }
        } else {
          $("#preloader").css('display', 'block');
          setTimeout(() => {
            $("#preloader").css('display', 'none');
            const theUser: any = JSON.parse(localStorage.getItem('currentUser'));
            if (theUser.user && theUser.user.newUser == 'firstTimeLogin' && (theUser.user.role == 'Learner' || theUser.user.role == 'Manager')) {
              this.startTour(event);
            }
          }, 200);
        }
      });

    } else {
      this.showIntroVideo = false;
      $('#animatedVideoModal').modal('hide');
    }

    let id = currentUser.user.userid;
    this.userService.getMessages(id).subscribe(res => {
      if (res.success) {
        this.getMessageCount = res.data.length;
        if (res.data.length == 0) {
          this.noMessage = false;
        } else {
          for (let i = 0; i < res.data.length; i++) {
            const obj = {
              'content': res.data[i].content,
              'sender': res.data[i].sender,
              'msg_id': res.data[i].msg_id,
              'licence_user_id': res.data[i].licence_user_id
            };
            this.showMessages.push(obj);
            this.noMessage = true;
          }
        }
      }
    });
    this.getAllNotifications(id);
    this.userService.usersProfilePic(currentUser.user.userid).subscribe(res => {
      console.log("user profile res", res.data);
      if (res.data != undefined) {
        $("#preloader").css('display', 'block');
        if (res.data.profile_pic) {
          // if (res.data.profile_pic.includes('data:image/')) {
          //   $("#profilePic").attr('src', Configuration.S3_BucketObjectURL+"/"+res.data.profile_pic);
          // } else {
          //   $("#profilePic").attr('src', Configuration.S3_BucketObjectURL+res.data.profile_pic);
          // }
          if (res.data.profile_pic.includes('PROFPIC')) {

            $("#profilePic").attr('src', Configuration.S3_BucketObjectURL + res.data.profile_pic);
            $("#profilePic1").attr('src', Configuration.S3_BucketObjectURL + res.data.profile_pic);
          } else {
            $("#profilePic").attr('src', 'data:image/png;base64,' + res.data.profile_pic);
            $("#profilePic1").attr('src', 'data:image/png;base64,' + res.data.profile_pic);
          }
          $("#preloader").css('display', 'none');
        } else {
          $("#preloader").css('display', 'none');
        }
      }
    });

    // Code to show logo for Community - DISABLED
    const commId = currentUser.user.community_id;
    if (currentUser.user.role == "Community Admin" || currentUser.user.role == "Learner" || currentUser.user.role == "Manager") {
      if (commId != "global") {
        this.communityLogoShow = true;
        this.userService.getCommunityLogo(commId).subscribe(res => {
          // console.log("res.data.image_data",res.data.image_data);
          this.imagedata = "data:image/png;base64" + res.data.image_data;
          $("#complogoImg").attr('src', "data:image/png;base64, " + res.data.image_data);
          $("#complogoImg1").attr('src', "data:image/png;base64, " + res.data.image_data);
          $("#complogoImg2").attr('src', "data:image/png;base64, " + res.data.image_data);
        });
      } else {
        this.communityLogoShow = false;
      }
    } else {
      this.communityLogoShow = false;
    }
    this.userService.getCommunityNameByCommunityID(currentUser.user.community_id)
      .subscribe(community => {
        this.community_name = community.data.comm_name;
        if (community.data.privacy_protected) {
          this.comm_privacy_protect = false;
        } else {
          this.comm_privacy_protect = true;
        }
      });
    document.addEventListener("Total Score", (e) => {
      this.getTotalScore(currentUser.user.userid);
    });

    this.getTotalScore(currentUser.user.userid);

    if (this.getRole == "Learner" || this.getRole == "Manager" || this.getRole == "Community Admin") {
      this.Payments = [{
        'name': 'Paypal'
      }];
    } else {
      this.Payments = [{
        'name': 'Direct'
      }, {
        'name': 'Paypal'
      }];
    }
  }

  getTotalScore(userid) {
    this.userService.getAllGamesTotalScore(userid)
      .subscribe(scores => {
        if (scores.data) {
          this.gamesTotalScore = scores.data;
        } else
          this.gamesTotalScore = 0;
      });
  }
  getAllNotifications(id) {
    this.notificationList = [];
    this.userService.getNotification(id).subscribe(res => {
      if (res.success) {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const obj = {
              'content': res.data[i].content,
              'sender': res.data[i].sender,
              'msg_id': res.data[i].msg_id,
              'licence_user_id': res.data[i].licence_user_id
            };
            this.notificationList.push(obj);
            this.noNotification = true;
          }
        } else {
          this.noNotification = false;
        }
        this.getNotificationCount = res.data.length;
      }
    });
  }
  startTour(event) {
    // alert("start tour");
    if (!event || (event && event.detail < 2)) {
      const theUser: any = JSON.parse(localStorage.getItem('currentUser'));
      if (theUser.user.role == 'Learner' || theUser.user.role == 'Manager') {
        this.GlobalService.getTranslationTour();
        let currentScreen = localStorage.getItem('currentScreen') ? localStorage.getItem('currentScreen') : 'HEADER';
        let stepArr = this.GlobalService.getRespectiveTourData(currentScreen);
        if (currentScreen == "MODULE_DETAILS") {
          if (document.getElementsByClassName("levelTour1").length == 0) {
            let index = stepArr.findIndex(step => step.element == ".levelTour1");
            stepArr.splice(index, 1);
          }
          if (document.getElementsByClassName("levelTour2").length == 0) {
            let index = stepArr.findIndex(step => step.element == ".levelTour2");
            stepArr.splice(index, 1);
          }
          if (document.getElementsByClassName("levelTour3").length == 0) {
            let index = stepArr.findIndex(step => step.element == ".levelTour3");
            stepArr.splice(index, 1);
          }
          if (!document.getElementById("instructionalTourTab")) {
            let index = stepArr.findIndex(step => step.element == "#instructionalTourTab");
            stepArr.splice(index, 1);
          }
          if (!document.getElementById("resourceTourTab")) {
            let index = stepArr.findIndex(step => step.element == "#resourceTourTab");
            stepArr.splice(index, 1);
          }
          if (!document.getElementById("certificationTourTab")) {
            let index = stepArr.findIndex(step => step.element == "#certificationTourTab");
            stepArr.splice(index, 1);
          }
        }
        this.tour = new Tour({
          debug: true,
          storage: false,
          backdrop: true,
          orphan: false,
          steps: stepArr,
          template: "<div class='popover tour'>" +
            "<div class='arrow'></div>" +
            "<h3 class='popover-title'></h3>" +
            "<div class='popover-content'></div>" +
            "<div class='popover-navigation'>" +
            "<div class='btn-group'><button class='btn btn-sm btn-default' data-role='prev'>« " + this.tourTranslateData.TOUR_PREV + "</button>" +
            "<button class='btn btn-sm btn-default' data-role='next'>" + this.tourTranslateData.TOUR_NEXT + " »</button></div>" +
            "<button class='btn btn-sm btn-default endTour' data-role='end'>" + this.tourTranslateData.TOUR_END + "</button></div></div>",
          onEnd: function (tour) {
            theUser.user.newUser = '';
            localStorage.setItem('currentUser', JSON.stringify(theUser));
          },
          onNext: function (tour) {
            if (currentScreen == 'JOURNEY_DETAILS' && tour._state.current_step >= 13) {
              // that.learnerDetailsCollapseBtn = true;
              $('#learner_tools_details').addClass('show');
            } else {
              // that.learnerDetailsCollapseBtn = false;
              $('#learner_tools_details').removeClass('show');
            }
          },
          onPrev: function (tour) {
            if (currentScreen == 'JOURNEY_DETAILS' && tour._state.current_step <= 14) {
              // that.learnerDetailsCollapseBtn = false;
              $('#learner_tools_details').removeClass('show');
            } else {
              // that.learnerDetailsCollapseBtn = true;
              $('#learner_tools_details').addClass('show');
            }
          },
        });
        // Initialize the tour
        this.tour.init();
        this.tour.start(true);
      }
    }
  }

  closeAnimatedVideoModal() {
    $('#animatedVideoModal').modal('hide');
    localStorage.setItem('guideVideoSeenStatus', 'false');
    if (this.localVideo == true) {
      this.animatedVideo.nativeElement.pause(); //Stop video after closing(Safal)
    } else if (this.vimeoPlayerFlag == false) {
      this.vimeoPlayer.pause(); //Stop video after closing(Safal)
      this.vimeoPlayer.destroy();
    } else if (this.youtubePlayerFlag == false) {
      this.player.pauseVideo(); //Stop video after closing(Safal)
    }
    const theUser: any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser.user && theUser.user.newUser == 'firstTimeLogin' && (theUser.user.role == 'Learner' || theUser.user.role == 'Manager')) {
      this.startTour(event);
    }
  }

  savePlayer(player) {
    this.player = player;
    this.player.loadVideoById(this.validateYTBUrl(this.videoSource), 0);
  }

  validateYTBUrl(videourl) {
    var Id;
    if (videourl.includes("v=")) {
      Id = videourl.split('v=')[1];
      var ampersandPosition = Id.indexOf('&');
      if (ampersandPosition != -1) {
        Id = Id.substring(0, ampersandPosition);
      }
    } else {
      Id = videourl.split("/").pop();
    }
    return Id;
  }

  logout() {
    // alert(this.authenticationType);
    let Typechecking = window.localStorage.getItem('Typechecking');
    const theUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log("user details", theUser);
    let loginUrl = this.cookieService.get('loginUrl');
    if(theUser == null && loginUrl){
      window.location.href = window.location.origin + "/login?token=" + loginUrl;
      let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;
      let lang_name = defaultLangData && defaultLangData.lang_name ? defaultLangData.lang_name : 'English';
      this.translate.reloadLang(lang_name);
      this.cookieService.delete('changeLanguage', '/');
    }
    let obj = {
      comm_id: theUser.user.community_id,
    }
    
    console.log("community id", theUser.user.community_id);
    
    if (this.authenticationType === 'COGNITO_AUTHENTICATION' || Typechecking === "COGNITO_AUTHENTICATION" || loginUrl) {
      this.userService.getRegisterDatafromCommunityID(obj)
        .subscribe(res => {
          console.log(res, "logout response")
          if (res.data.subDomainName) {
            window.location.href = res.data.subDomainName + "/login";
            let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;
            let lang_name = defaultLangData && defaultLangData.lang_name ? defaultLangData.lang_name : 'English';
            this.translate.reloadLang(lang_name);
            this.cookieService.delete('changeLanguage', '/');
            // this.cookieService.delete('defaultLangData', '/');
          } else {
            window.location.href = window.location.origin + "/login?token=" + res.data.loginUrl;
            let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;
            let lang_name = defaultLangData && defaultLangData.lang_name ? defaultLangData.lang_name : 'English';
            this.translate.reloadLang(lang_name);
            this.cookieService.delete('changeLanguage', '/');
            // this.cookieService.delete('defaultLangData', '/');

          }

        })
      // window.location.reload(true);
    } else {
      this.AuthService.logout().subscribe(log => {
        let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;
        let lang_name = defaultLangData && defaultLangData.lang_name ? defaultLangData.lang_name : 'English';
        this.translate.reloadLang(lang_name);
        this.cookieService.delete('changeLanguage', '/');
        // this.cookieService.delete('defaultLangData', '/');
      });
      // window.location.reload(true);
    }
    this.GlobalService.changeMessage(false); 
  }

  closeMsgModal(selectedMessage) {
    const theUser: any = JSON.parse(localStorage.getItem('currentUser'));
    const user_id = theUser.user.userid;

    const Obj = {
      msg_id: selectedMessage.msg_id,
      updated_by: user_id
    };

    if (selectedMessage.type == "message") {
      this.userService.markReadMsg(Obj).subscribe(messages => {
        if (messages.success) {
          this.showMessages = [];
          this.userService.getMessages(user_id).subscribe(res => {
            this.getMessageCount = res.data.length;
            if (res.data.length == 0) {
              this.noMessage = false;
            } else {
              for (let i = 0; i < res.data.length; i++) {
                const obj = {
                  'content': res.data[i].content,
                  'sender': res.data[i].sender,
                  'msg_id': res.data[i].msg_id,
                  'licence_user_id': res.data[i].licence_user_id
                };
                this.showMessages.push(obj);
                this.noMessage = true;
              }
            }
          });
        }
      });
    } else if (selectedMessage.type == "notification") {
      if (selectedMessage.action == 'NewlyAddedData' || (selectedMessage.action == 'certificateDueDate' && selectedMessage.priority == 'normal')) {
        this.userService.markReadMsg(Obj).subscribe(messages => {
          if (messages.success) {
            this.notificationList = [];
            this.userService.getNotification(user_id).subscribe(res => {
              this.getNotificationCount = res.data.length;
              if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                  const obj = {
                    'content': res.data[i].content,
                    'sender': res.data[i].sender,
                    'msg_id': res.data[i].msg_id,
                    'licence_user_id': res.data[i].licence_user_id
                  };
                  this.notificationList.push(obj);
                  this.noNotification = true;
                }
              } else {
                this.noNotification = false;
              }
            });
          }
        });
      }
    }
    $('#msgDisplay').modal('hide');
  }

  lic_name: string;

  renewLicense(licence_user_id) {
    this.subscriptionForm.resetForm();
    this.subscriptionFormL.resetForm();
    $("#paypal-button-header").empty();
    $("#learnerpaypal-button-header").empty();
    $('#msgDisplay').modal('hide');
    this.selectedMsgId = this.selectedMessage.msg_id;
    this.userService.getSubLicenseById(licence_user_id).subscribe(res => {
      this.noofLicenses = res.data.no_of_license;
      this.licence_user_id = licence_user_id;
      this.userService.getLicenseById(res.data.licence_id).subscribe(license => {
        this.duration = license.data.duration;
        this.paidStatus = license.data.paid_status;
        this.selected_courses = license.data.selected_courses;
        this.selected_certificates = license.data.selected_certificates;
        this.selected_journeys = license.data.selected_journeys ? license.data.selected_journeys : [];
        this.licence_id = res.data.licence_id;
        this.term = res.data.term;
        this.licence_name = license.data.licence_name;
        this.price = license.data.price;
        this.lic_name = license.data.licence_name;
        this.subtotal = this.noofLicenses * this.price;
        this.TotalPrice = this.noofLicenses * this.price;
        const theUser: any = JSON.parse(localStorage.getItem('currentUser'));
        var userID = theUser.user.userid;
        let obj = {
          licence_id: this.licence_id,
          licence_duration: this.duration,
          price: this.TotalPrice,
          term: this.term,
          no_of_license: this.noofLicenses,
          no_of_used_license: this.noofLicenses,
          selected_courses: this.selected_courses,
          selected_certificates: this.selected_certificates,
          selected_journeys: this.selected_journeys,
          user_id: userID,
          created_by: userID,
          created_date: new Date().getTime(),
          coupon_code: '',
          licence_user_id: this.licence_user_id,
          original_price: this.TotalPrice,
          no_of_coupons: 0,
          licence_name: this.lic_name
        };
        this.valArr.push(obj);
        this.paypalButtonShow();
      });
    });
  }

  changePaymentMode(flag) {
    $("#paypal-button-header").empty();
    $("#learnerpaypal-button-header").empty();
    const theUser: any = JSON.parse(localStorage.getItem('currentUser'));
    let couponData;
    if (this.appliedCoupons != undefined && this.appliedCoupons != 0) {
      couponData = {
        coupon_id: this.coupon_id,
        no_of_coupon_used: this.appliedCoupons
      };
    }
    let c_data = couponData ? JSON.stringify(couponData) : "";
    let tokenData = {
      user_id: theUser.user.userid,
      price: this.TotalPrice,
      url: '',
      subscriptionData: this.valArr,
      user_name: theUser.user.username,
      fullname: theUser.user.fullname,
      couponData: c_data,
      licence_renew: true,
      redirect_URL: '/dashboard/learner/learnerDashboard',
      optional_params: JSON.stringify(this.valArr)
    };
    if (this.paymentBy == 'Paypal' && this.TotalPrice > 0) {
      $("#preloader").css('display', 'block');
      let that = this;

      $('#msgDivHeader').remove();
      $(".mainDivHeader").show();
      $(".expressCheckoutDivHeader").show();
      $("#paypal-button-header").empty();
      paypal.Button.render({
        env: Configuration.PayPal_Mode,
        style: {
          size: 'medium',
          color: 'gold',
          shape: 'rect',
          label: 'checkout',
          tagline: false,
          height: 35
        },
        // Set up the payment:
        // 1. Add a payment callback
        payment: function (data, actions) {
          // 2. Make a request to your server
          return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/' + that.TotalPrice + '?token=' + theUser.token, tokenData)
            .then(function (res) {
              // 3. Return res.id from the response
              return res.id;
            });
        },
        // Execute the payment:
        // 1. Add an onAuthorize callback
        onAuthorize: (data, actions) => {
          // 2. Make a request to your server
          return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + that.TotalPrice + '?token=' + theUser.token, {
            paymentID: data.paymentID,
            payerID: data.payerID,
          })
            .then((res) => {
              // 3. Show the buyer a confirmation message.

              if (res.statusCode == 200) {
                let AMT = res.data.price;
                let PNREF = res.data.PNREF;

                $(".mainDivHeader").hide();
                $(".expressCheckoutDivHeader").hide();
                let div = "<div id='msgDivHeader' style='text-align: center;'>" +
                  '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                  '<p style="font-family: Helvetica;color:#0072BC;">' + this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_SUCCESS'] + '</p>' +
                  '<br>' +
                  '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">' + this.tourTranslateData['SUBSCRIPTION_FORM.AMOUNT_PAID'] + '</p>' +
                  '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ ' + AMT + '</p>' +
                  '<br>' +
                  '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">' + this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_ID'] + ' <span style="font-family: Helvetica;color:#000;">' + PNREF + '</span></p>' +
                  "</div>";
                $('#msgDivHeader').remove();
                $('#renewModal').modal('hide');
                $('#learnerRenewModal').modal('hide');
                $('#renewModal').modal('hide');
                $('#learnerRenewModal').modal('hide');
                $('#notificationSuccessModal').modal('show');
                $("#payPalModalHeader").append(div);
              }
            });
        }
      }, '#paypal-button-header');
      $("#preloader").css('display', 'none');
    } else {
      $("#paypal-button-header").empty();
    }
  }

  paypalButtonShow() {
    this.paymentBy = this.getRole == "Alignor Admin" ? undefined : "Paypal";
    const theUser: any = JSON.parse(localStorage.getItem('currentUser'));
    let couponData;
    if (this.appliedCoupons != undefined && this.appliedCoupons != 0) {
      couponData = {
        coupon_id: this.coupon_id,
        no_of_coupon_used: this.appliedCoupons
      };
    }
    let c_data = couponData ? JSON.stringify(couponData) : "";
    let tokenData = {
      user_id: theUser.user.userid,
      price: this.TotalPrice,
      url: '',
      subscriptionData: this.valArr,
      user_name: theUser.user.username,
      fullname: theUser.user.fullname,
      couponData: c_data,
      licence_renew: true,
      redirect_URL: '/dashboard/learner/learnerDashboard',
      optional_params: JSON.stringify(this.valArr)
    };
    if (this.getRole == 'Learner' || this.getRole == 'Manager') {
      $('#learnerRenewModal').modal('show');
      if (this.TotalPrice > 0) {
        $("#preloader").css('display', 'block');
        let that = this;

        $('#msgDivHeader').remove();
        $(".mainDivHeader").show();
        $(".learnerexpressCheckoutDivHeader").show();
        $("#learnerpaypal-button-header").empty();
        paypal.Button.render({
          env: Configuration.PayPal_Mode,
          style: {
            size: 'medium',
            color: 'gold',
            shape: 'rect',
            label: 'checkout',
            tagline: false,
            height: 35
          },
          // Set up the payment:
          // 1. Add a payment callback
          payment: function (data, actions) {
            // 2. Make a request to your server
            return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/' + that.TotalPrice + '?token=' + theUser.token, tokenData)
              .then(function (res) {
                // 3. Return res.id from the response
                return res.id;
              });
          },
          // Execute the payment:
          // 1. Add an onAuthorize callback
          onAuthorize: (data, actions) => {
            // 2. Make a request to your server
            return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + that.TotalPrice + '?token=' + theUser.token, {
              paymentID: data.paymentID,
              payerID: data.payerID,
            })
              .then((res) => {
                // 3. Show the buyer a confirmation message.

                if (res.statusCode == 200) {
                  let AMT = res.data.price;
                  let PNREF = res.data.PNREF;

                  $(".mainDivHeader").hide();
                  $(".learnerexpressCheckoutDivHeader").hide();
                  let div = "<div id='msgDivHeader' style='text-align: center;'>" +
                    '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                    '<p style="font-family: Helvetica;color:#0072BC;">' + this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_SUCCESS'] + '</p>' +
                    '<br>' +
                    '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">' + this.tourTranslateData['SUBSCRIPTION_FORM.AMOUNT_PAID'] + '</p>' +
                    '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ ' + AMT + '</p>' +
                    '<br>' +
                    '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">' + this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_ID'] + ' <span style="font-family: Helvetica;color:#000;">' + PNREF + '</span></p>' +
                    "</div>";
                  $('#msgDivHeader').remove();
                  $('#renewModal').modal('hide');
                  $('#learnerRenewModal').modal('hide');
                  $("#payPalModalHeader").append(div);
                  $('#notificationSuccessModal').modal('show');
                }
              });
          }
        }, '#learnerpaypal-button-header');

        setTimeout(() => {
          $("#preloader").css('display', 'none');
          $("#headerPayFlowFrameDiv").empty();
        }, 500);

      } else {
        $("#learnerpaypal-button-header").empty();
      }
    } else if (this.getRole == 'Community Admin') {
      setTimeout("$('#renewModal').modal('show');", 500);
      if (this.TotalPrice > 0) {
        $("#preloader").css('display', 'block');
        let that = this;

        $('#msgDivHeader').remove();
        $(".mainDivHeader").show();
        $(".expressCheckoutDivHeader").show();
        $("#paypal-button-header").empty();
        paypal.Button.render({
          env: Configuration.PayPal_Mode,
          style: {
            size: 'medium',
            color: 'gold',
            shape: 'rect',
            label: 'checkout',
            tagline: false,
            height: 35
          },
          // Set up the payment:
          // 1. Add a payment callback
          payment: function (data, actions) {
            // 2. Make a request to your server
            return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/' + that.TotalPrice + '?token=' + theUser.token, tokenData)
              .then(function (res) {
                // 3. Return res.id from the response
                return res.id;
              });
          },
          // Execute the payment:
          // 1. Add an onAuthorize callback
          onAuthorize: (data, actions) => {
            // 2. Make a request to your server
            return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + that.TotalPrice + '?token=' + theUser.token, {
              paymentID: data.paymentID,
              payerID: data.payerID,
            })
              .then((res) => {
                // 3. Show the buyer a confirmation message.

                if (res.statusCode == 200) {
                  let AMT = res.data.price;
                  let PNREF = res.data.PNREF;

                  $(".mainDivHeader").hide();
                  $(".expressCheckoutDivHeader").hide();
                  let div = "<div id='msgDivHeader' style='text-align: center;'>" +
                    '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                    '<p style="font-family: Helvetica;color:#0072BC;">' + this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_SUCCESS'] + '</p>' +
                    '<br>' +
                    '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">' + this.tourTranslateData['SUBSCRIPTION_FORM.AMOUNT_PAID'] + '</p>' +
                    '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ ' + AMT + '</p>' +
                    '<br>' +
                    '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">' + this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_ID'] + ' <span style="font-family: Helvetica;color:#000;">' + PNREF + '</span></p>' +
                    "</div>";
                  $('#msgDivHeader').remove();
                  $('#renewModal').modal('hide');
                  $('#learnerRenewModal').modal('hide');
                  $('#notificationSuccessModal').modal('show');
                  $("#payPalModalHeader").append(div);

                }
              });
          }
        }, '#paypal-button-header');

        setTimeout(() => {
          $("#preloader").css('display', 'none');
          $("#headerPayFlowFrameDiv").empty();
        }, 500);

      } else {
        $("#paypal-button-header").empty();
      }
    } else {
      setTimeout("$('#renewModal').modal('show');", 500);
    }
  }
  calcPrice() {
    this.subtotal = 0;
    this.subtotal = this.noofLicenses * this.price;
    this.TotalPrice = this.subtotal;
  }

  applyCoupon() {
    $("#paypal-button-header").empty();
    $("#learnerpaypal-button-header").empty();
    this.valArr = [];
    const theUser: any = JSON.parse(localStorage.getItem('currentUser'));
    var userID = theUser.user.userid;
    const communityId = theUser.user.community_id;
    let AllLicenseUsed;
    let TotalPrice = 0;
    this.discountPrice = 0;
    this.TotalPrice = 0;
    let availableCoupons = 0;
    let usedCoupons = 0;
    let couponsData;
    if (this.coupon_code == undefined || this.coupon_code == '') {
      this.couponValidationMsg = "103";
      this.InvalidCoupon = true;
      const price = this.price;
      this.discountPrice = 0;
      let nooflicense = this.noofLicenses;
      TotalPrice = nooflicense * price;
      this.TotalPrice = this.TotalPrice + TotalPrice;
      let obj = {
        licence_id: this.licence_id,
        licence_duration: this.duration,
        price: TotalPrice,
        term: this.term,
        no_of_license: this.noofLicenses,
        no_of_used_license: this.noofLicenses,
        selected_courses: this.selected_courses,
        selected_certificates: this.selected_certificates,
        selected_journeys: this.selected_journeys,
        user_id: userID,
        created_by: userID,
        created_date: new Date().getTime(),
        coupon_code: '',
        licence_user_id: this.licence_user_id,
        original_price: TotalPrice,
        no_of_coupons: 0,
        licence_name: this.lic_name
      };
      this.valArr.push(obj);
    } else {
      this.InvalidCoupon = false;
      this.appliedCoupons = 0;
      this.LicenseService.getCouponsByCode(this.coupon_code, communityId).subscribe(coupandata => {
        this.couponValidationMsg = coupandata.statusCode;
        if (coupandata.success == true) {
          this.coupon_id = coupandata.data.coupon_id;
          if (coupandata.data.no_of_coupon_used == undefined) {
            usedCoupons = 0;
          } else {
            usedCoupons = coupandata.data.no_of_coupon_used;
          }
          if (usedCoupons == coupandata.data.no_of_coupon_ava) {
            this.couponValidationMsg = "101";
            this.InvalidCoupon = true;
            const price = this.price;
            this.discountPrice = 0;
            let nooflicense = this.noofLicenses;
            TotalPrice = nooflicense * price;
            this.TotalPrice = this.TotalPrice + TotalPrice;
            let obj = {
              licence_id: this.licence_id,
              licence_duration: this.duration,
              price: TotalPrice,
              term: this.term,
              no_of_license: nooflicense,
              no_of_used_license: nooflicense,
              selected_courses: this.selected_courses,
              selected_certificates: this.selected_certificates,
              selected_journeys: this.selected_journeys,
              user_id: userID,
              created_by: userID,
              created_date: new Date().getTime(),
              coupon_code: '',
              licence_user_id: this.licence_user_id,
              original_price: TotalPrice,
              no_of_coupons: 0,
              licence_name: this.lic_name
            };
            this.valArr.push(obj);

          } else {
            let original_price = 0;
            let no_of_coupons = 0;
            this.appliedCoupons = usedCoupons;
            availableCoupons = coupandata.data.no_of_coupon_ava - usedCoupons;
            const price = this.price;
            let nooflicense = this.noofLicenses;
            TotalPrice = 0;
            let coupon_code = '';
            original_price = price * nooflicense;
            if (this.paidStatus == 'paid') {
              if (coupandata.data.coupon_type == 'Number Based') {
                availableCoupons > 0 ? coupon_code = this.coupon_code : coupon_code = '';
                if (coupandata.data.discount_type == "Price") {
                  for (let i = 0; i < nooflicense; i++) {
                    if (availableCoupons > 0) {
                      const total = price - coupandata.data.discount;
                      TotalPrice = TotalPrice + total;
                      availableCoupons--;
                      this.appliedCoupons++;
                      no_of_coupons++;
                    } else {
                      TotalPrice = TotalPrice + price;
                    }
                  }
                } else if (coupandata.data.discount_type == "Percentage") {
                  for (let i = 0; i < nooflicense; i++) {
                    if (availableCoupons > 0) {
                      const total = price - (price * coupandata.data.discount) / 100;
                      TotalPrice = TotalPrice + total;
                      availableCoupons--;
                      this.appliedCoupons++;
                      no_of_coupons++;
                    } else {
                      TotalPrice = TotalPrice + price;
                    }
                  }
                }
              } else if (coupandata.data.coupon_type == 'Time Based') {
                this.appliedCoupons = undefined;
                const today = new Date();
                let currDate = new Date((today.getMonth() + 1) + "/" + (today.getDate()) + "/" + today.getFullYear()).getTime();
                if (currDate < coupandata.data.start_date) {
                  this.couponValidationMsg = "202";
                  this.InvalidCoupon = true;
                  TotalPrice = nooflicense * price;
                  coupon_code = '';
                  no_of_coupons = 0;
                } else if (currDate >= coupandata.data.start_date && currDate <= coupandata.data.end_date) {
                  coupon_code = this.coupon_code;
                  if (coupandata.data.discount_type == "Price") {
                    for (let i = 0; i < nooflicense; i++) {
                      const total = price - coupandata.data.discount;
                      TotalPrice = TotalPrice + total;
                      no_of_coupons++;
                    }
                  } else if (coupandata.data.discount_type == "Percentage") {
                    TotalPrice = 0;
                    for (let i = 0; i < nooflicense; i++) {
                      const total = price - (price * coupandata.data.discount) / 100;
                      TotalPrice = TotalPrice + total;
                      no_of_coupons++;
                    }
                  }
                } else {
                  this.couponValidationMsg = "102";
                  this.InvalidCoupon = true;
                  TotalPrice = nooflicense * price;
                  no_of_coupons = 0;
                }
              }
            } else {
              TotalPrice = nooflicense * price;
              coupon_code = '';
              no_of_coupons = 0;
            }

            this.TotalPrice = this.TotalPrice + TotalPrice;
            if (this.TotalPrice < 0) {
              this.TotalPrice = 0;
            }

            this.discountPrice = this.discountPrice + (original_price - TotalPrice);
            if (this.discountPrice < 0) {
              this.discountPrice = 0;
            }


            let obj = {
              licence_id: this.licence_id,
              licence_duration: this.duration,
              price: TotalPrice,
              term: this.term,
              no_of_license: this.noofLicenses,
              no_of_used_license: this.noofLicenses,
              selected_courses: this.selected_courses,
              selected_certificates: this.selected_certificates,
              selected_journeys: this.selected_journeys,
              user_id: userID,
              created_by: userID,
              created_date: new Date().getTime(),
              coupon_code: coupon_code,
              licence_user_id: this.licence_user_id,
              original_price: original_price,
              no_of_coupons: no_of_coupons,
              licence_name: this.lic_name
            };
            this.valArr.push(obj);
          }
        } else {
          this.couponValidationMsg = coupandata.statusCode;
          this.InvalidCoupon = true;
          const price = this.price;
          this.discountPrice = 0;
          let nooflicense = this.noofLicenses;
          TotalPrice = nooflicense * price;
          this.TotalPrice = this.TotalPrice + TotalPrice;
          if (this.TotalPrice < 0) {
            this.TotalPrice = 0;
          }
          let obj = {
            licence_id: this.licence_id,
            licence_duration: this.duration,
            price: this.TotalPrice,
            term: this.term,
            no_of_license: nooflicense,
            no_of_used_license: nooflicense,
            selected_courses: this.selected_courses,
            selected_certificates: this.selected_certificates,
            selected_journeys: this.selected_journeys,
            user_id: userID,
            created_by: userID,
            created_date: new Date().getTime(),
            coupon_code: '',
            licence_user_id: this.licence_user_id,
            original_price: this.TotalPrice,
            no_of_coupons: 0,
            licence_name: this.lic_name
          };
          this.valArr.push(obj);
        }
        if (this.TotalPrice > 0) {
          this.paypalButtonShow();
        } else {
          $("#paypal-button-header").empty();
          $("#learnerpaypal-button-header").empty();
        }
      });
    }
  }

  checkCouponCode() {
    $("#paypal-button-header").empty();
    $("#learnerpaypal-button-header").empty();
    const theUser: any = JSON.parse(localStorage.getItem('currentUser'));
    let userID = theUser.user.userid;
    this.couponValidationMsg = "";
    this.discountPrice = 0;
    if (this.coupon_code == '') {
      this.valArr = [];
      this.TotalPrice = 0;
      this.appliedCoupons = 0;
      let TotalPrice = 0;
      let price = this.price;
      if (price == undefined) {
        price = 0;
      }
      let nooflicense = this.noofLicenses;
      TotalPrice = nooflicense * price;
      this.TotalPrice = this.TotalPrice + TotalPrice;
      if (this.TotalPrice < 0) {
        this.TotalPrice = 0;
      }

      let obj = {
        licence_id: this.licence_id,
        licence_duration: this.duration,
        price: this.TotalPrice,
        term: this.term,
        no_of_license: nooflicense,
        no_of_used_license: nooflicense,
        selected_courses: this.selected_courses,
        selected_certificates: this.selected_certificates,
        selected_journeys: this.selected_journeys,
        user_id: userID,
        created_by: userID,
        created_date: new Date().getTime(),
        coupon_code: '',
        licence_user_id: this.licence_user_id,
        original_price: this.TotalPrice,
        no_of_coupons: 0,
        licence_name: this.lic_name
      };
      this.valArr.push(obj);

      if (this.TotalPrice > 0) {
        this.paypalButtonShow();
      } else {
        $("#paypal-button-header").empty();
        $("#learnerpaypal-button-header").empty();
      }
    }
  }

  subscribeLicense(subscriptionForm, flag) {
    this.agreement = undefined;
    $('#msgDivHeader').remove();
    const theUser: any = JSON.parse(localStorage.getItem('currentUser'));
    let userID = theUser.user.userid;
    if (this.valArr.length == 0) {
      this.valArr = [];
      this.discountPrice = 0;
      this.TotalPrice = 0;
      const price = this.price;
      let nooflicense = this.noofLicenses;
      const total = nooflicense * price;
      this.TotalPrice = this.TotalPrice + total;
      let obj = {
        licence_id: this.licence_id,
        licence_duration: this.duration,
        price: this.TotalPrice,
        term: this.term,
        no_of_license: this.noofLicenses,
        no_of_used_license: this.noofLicenses,
        selected_courses: this.selected_courses,
        selected_certificates: this.selected_certificates,
        selected_journeys: this.selected_journeys,
        user_id: userID,
        created_by: userID,
        created_date: new Date().getTime(),
        coupon_code: this.coupon_code,
        licence_user_id: this.licence_user_id,
        original_price: this.TotalPrice,
        no_of_coupons: 0,
        licence_name: this.lic_name
      };
      this.valArr.push(obj);
    }
    if (this.valArr && this.valArr.length > 0) {
      let couponData;
      if (this.appliedCoupons != undefined && this.appliedCoupons != 0) {
        couponData = {
          coupon_id: this.coupon_id,
          no_of_coupon_used: this.appliedCoupons
        };
      }
      if (this.paymentBy == 'Paypal' && this.TotalPrice > 0) {
        $("#preloader").css('display', 'block');
        let c_data = couponData ? JSON.stringify(couponData) : "";
        let tokenData = {
          user_id: theUser.user.userid,
          price: this.TotalPrice,
          url: '',
          subscriptionData: this.valArr,
          user_name: theUser.user.username,
          fullname: theUser.user.fullname,
          couponData: c_data,
          licence_renew: true,
          redirect_URL: '/dashboard/learner/learnerDashboard',
          optional_params: JSON.stringify(this.valArr)
        };

        let that = this;

        $('#msgDivHeader').remove();
        $(".mainDivHeader").show();
        $("#expressCheckoutDivHeader").show();
        $("#paypal-button-header").empty();
        paypal.Button.render({
          env: Configuration.PayPal_Mode,
          style: {
            size: 'medium',
            color: 'gold',
            shape: 'rect',
            label: 'checkout',
            tagline: false,
            height: 35
          },
          // Set up the payment:
          // 1. Add a payment callback
          payment: function (data, actions) {
            // 2. Make a request to your server
            return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/' + that.TotalPrice + '?token=' + theUser.token, tokenData)
              .then(function (res) {
                // 3. Return res.id from the response
                return res.id;
              });
          },
          // Execute the payment:
          // 1. Add an onAuthorize callback
          onAuthorize: (data, actions) => {
            // 2. Make a request to your server
            return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + that.TotalPrice + '?token=' + theUser.token, {
              paymentID: data.paymentID,
              payerID: data.payerID,
            })
              .then((res) => {
                // 3. Show the buyer a confirmation message.

                if (res.statusCode == 200) {
                  let AMT = res.data.price;
                  let PNREF = res.data.PNREF;

                  $(".mainDivHeader").hide();
                  $("#expressCheckoutDivHeader").hide();
                  let div = "<div id='msgDivHeader' style='text-align: center;'>" +
                    '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                    '<p style="font-family: Helvetica;color:#0072BC;">' + this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_SUCCESS'] + '</p>' +
                    '<br>' +
                    '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">' + this.tourTranslateData['SUBSCRIPTION_FORM.AMOUNT_PAID'] + '</p>' +
                    '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ ' + AMT + '</p>' +
                    '<br>' +
                    '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">' + this.tourTranslateData['SUBSCRIPTION_FORM.TRANSACTION_ID'] + ' <span style="font-family: Helvetica;color:#000;">' + PNREF + '</span></p>' +
                    "</div>";
                  $('#renewModal').modal('hide');
                  $('#learnerRenewModal').modal('hide');
                  $('#notificationSuccessModal').modal('show');
                  $('#msgDivHeader').remove();
                  $("#payPalModalHeader").append(div);
                }
              });
          }
        }, '#paypal-button-header');




        setTimeout(() => {
          $("#preloader").css('display', 'none');

          $("#headerPayFlowFrameDiv").empty();
        }, 500);

      } else {
        this.updateLicense();
        subscriptionForm.reset();
      }
      this.selectedLicensesList = [];
      $('#renewModal').modal('hide');
      $('#learnerRenewModal').modal('hide');
    }
  }
  closeModal() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.getAllNotifications(currentUser.user.userid);
    $('#notificationSuccessModal').modal('hide');
  }
  getMessageId(messageIndex) {
    this.userService.getMsgById(messageIndex)
      .subscribe(msg => {
        if (msg.success) {
          this.selectedMessage = msg.data;
          $('#msgDisplay').modal('show');
          this.msg_content = msg.data.content;
        }
      })
  }

  closePayflowModel() {
    this.subscriptionForm.reset();
    this.subscriptionFormL.reset();
    this.TotalPrice = 0;
    this.subtotal = 0;
    this.InvalidCoupon = false;
    this.paymentBy = undefined;
    this.coupon_id = undefined;
    this.appliedCoupons = 0;
    this.TotalPrice = 0;
    this.subtotal = 0;
    this.discountPrice = 0;
    $('#msgDivHeader').remove();
    $("#headerPayFlowFrameDiv").empty();
    $("#paypal-button-header").empty();
  }


  closeModel(subscriptionForm) {
    subscriptionForm.reset();
    this.TotalPrice = 0;
    this.subtotal = 0;
    this.InvalidCoupon = false;
    this.discountPrice = 0;
    this.agreement = undefined;
    this.paymentBy = undefined;
    this.couponValidationMsg = '';
  }


  slideNotificationPanel() {
    // if ($('.sideMenunav').hasClass('displayMenu')) {
    //   $('.sideMenunav').removeClass('displayMenu');
    // } else {
    //   $('.sideMenunav').addClass('displayMenu');
    // }

    $(".navbar-collapse").removeClass("show");
    $(".asideRight").toggleClass("asideRightOpen");
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.userService.getNotification(currentUser.user.userid).subscribe(res => {
      if (res.success) {
        this.notificationList = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const obj = {
              'content': res.data[i].content,
              'sender': res.data[i].sender,
              'msg_id': res.data[i].msg_id,
              'licence_user_id': res.data[i].licence_user_id
            };

            this.notificationList.push(obj);
            this.noNotification = true;
          }
        } else {
          this.noNotification = false;
        }
        this.getNotificationCount = res.data.length;
      }
    });
  }
  closeRightPanel() {
    $(".asideRight").removeClass("asideRightOpen");
  }

  toggleSidenav() {
    $('.sidenav').toggleClass('sidenavSlide');

  }
  checkLicenseNumber(value) {
    this.calcPrice();
    if (value == 0) {
      this.couponValidationMsg = "100";
    } else {
      this.couponValidationMsg = "";
    }
  }

  changeURL(e) {
    if (this.getRole == "Alignor Admin") {
      this.router.navigate(['/dashboard/portal/portalDashboard']);
    } else if (this.getRole == "Community Admin") {
      this.router.navigate(['/dashboard/portal/communityDashboard']);
    } else if (this.getRole == "Learner" || this.getRole == "Manager") {
      this.router.navigate(['/dashboard/learner/learnerDashboard']);
    }
  }

  changeProfilePic() {
    $('#profilePicModal').modal('show');
    this.translate.get('SELECT_PROFILE_PIC').subscribe(label => {
      this.fileUpload = label;
    });
  }

  updateProfile() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.errorMsg = "";
    $("#preloader").css('display', 'block');
    this.userService.usersProfilePic(currentUser.user.userid)
      .subscribe(user => {
        if (user.success) {
          this.userService.getCommunityLogo(user.data.community_id)
            .subscribe(community => {
              if (community.success) {
                this.User = user.data;
                this.User.comm_role = user.data.comm_role && user.data.comm_role.length > 0 && user.data.comm_role != 'None' ? user.data.comm_role : undefined;
                this.User.business_unit = user.data.business_unit && user.data.business_unit.length > 0 && user.data.business_unit != 'None' ? user.data.business_unit : undefined;
                this.User.organization = community.data.org_name;
                if (this.User.country) {
                  let a = this.countryCodeList.findIndex(code => code.name == this.User.country);
                  if (a > -1) {
                    this.countryCode = this.countryCodeList[a].code;
                    this.countryId = this.countryCodeList[a].iso2;
                  } else {
                    this.countryCode = undefined;
                    this.countryId = undefined;
                  }
                } else {
                  this.countryCode = undefined;
                  this.countryId = undefined;
                }
                this.getAllRoleBUnit();
                $("#preloader").css('display', 'none');
                $('#updateProfileModal').modal('show');
              }
            });
        }
      });
  }

  onChange(event, files: FileList) {
    this.files = event.target.files;
    this.fileUpload = files.item(0).name;
    let data = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAUVBMVEXk5ueutLfl5+ja3N2pr7Ovtbjr7O2nrrHo6uvt7u+lrK+1ur2rsrWiqa3g4uPj5ubIzM7BxcfT1tjM0NK7wMPEycu0ur3V2dre3+LLztHx8/LRxzGyAAAIKUlEQVR4nO2di5KjNhBFQegJguHtsf//QyMZ7ya7Me/bHkRxUqmtTGXHnKHploTUE9XJuamjgp2bIkpYdGZYchmGzmUYPpdh+FyG4XMZhs9lGD6XYfhchuFzGYbPZRg+l2H4XIbhcxmGz2UYPpdh+FyG4XMZhs9lGD6XYfhchuFzGYI/TUtpPFp/7EM/Zci01lIXSd0097Jp6qRgUn7E8zOGXu5WtiK2XCnu/7WxaLvaaWrqz/6EoXkUTcuVdcS/cf/BFe/LwhjaTyc31JI1fZ5bEb9B2DwXpSa9kcSGzET3WKn4rd8AV3FXGDpHWkNjShed43avgOWq1GSxSmnIZG3zOb0hWlNVUt1GQkMZtYpPhOefD2Tafpvoi+AyqAy/InOzapneAOfNg+JKiAy/tGmXBei/tzHOW00QqUSGLkLTdYLeMe0LCb8UGkP5JVZF6C9FriJ4TiUxlEW+NMX8pWjzG1qRwlAWdpugV+RoRQJDHcVbBZ93scAq4g21XlwF3yrGqoBmVLgh05naIejTjWBIRbih6fYJOkWVPYAXhDY0zcpC/04xL4GPIthQR+nsVGIBKsHFKdaQmXZLpf8fvMeNbbCGskl3PoQv0goWp1BDFsWIGPXkkQZNpaCGj2r9cPs9QrUSdFlIQzccBQn6ecYNlGyAhkxWe0vhf+AZKNkADXUBFPQVA6MINJQVBwoK1T8guQZnCEykAzlmBI4zNA2k2P9GpCUkTIGGAhmkTyLETYQZamCpeKEgBQNm6CYVyEzq4RUiTFGGjGXYPOOwAnJlIENd7Fm6GIEjJlEwwxqbSZ8oxEwYZljBg9QZ9kcyxD+G/k04YCsDLJeCBzQDKWBYAzLUCbzcx35J6ra/XoAMJXjI9iJvDmNoShJD1R0mSh+YNba/se3+VIO6h0SGGTuMYU9iGIvoKIYSP3UaOIohIzPcXxBRhiQF3z2Il+HnDM8epYSZ5iiGJjt7tTh/xScbtR3G0HRnH3lTzZ7uh5k9nX8GfP5VjEj3Z1+JkudfTTz/inBBkGoOtarPGP5BPNabGVcRT/52DbqZ5sXB3pASvOW2x3rLHZn72XcqEOw2OZghescQR5T76Nr1te5bnX7n3vl3XyJ30Mb8kDtoXTq1sF3QsIMz4J3sd8xOdpG2sEMl4NMIsoUkm+OeRgCdKBGoSuE55qmg7ringvzK6d5H0e9/Bl4Sxem8fXv43BQFMqf4fUH4E5Ys3aeIfAgjklOy0lXF7YoBnJJ1ignfqiisqg22dwTVafVtiiLO6xBOq7uEWsTbOg6k4BCNCLtGZFu6Rgi8IFlvEy3Xdv5whT6DHuJ+QdefxtR81aoGV+WDogkPYQce4yJ1acIRNs0SQ3IhlF2UtGzUsqdRpGkXYBclh5HdfCcsYbnqWJCdsPy3N0VpFRfjwSrcj6AqCDu2kXekYzK6i9GOdHGax10Ucke6J8Z8l5l601WQq6wLv6vgEyl1UXeZ8FJcebiNs6rxDTCpP/uT3T01K251U3Zdea9v374h5nm6e/76MCaNeTxbtMr927mWfugHDH3nWen7sWr/i8CfX3Ho11epVWkNnZtvqRv53rNlV7VtlvV9n/l/2qrqmvrme9H6/4XwGogMh666UdJ0bRbzNM/T1KeXIZ36P6xSqfty7oplX5U3342W5rEkMXTx5+Wqfuiqa5+V7209FPGr8a4VbVkX7p7DLQlWolyBS8rWFQa74i3G0HRXVHWhH6h3MgNYQx+ZSdmrfPGk4i/c34ydJbKOQN+QyujWuXGm2rHUJoR7QG3bFLDmwjBD5sZmnR0eun2I2KehtnYzE8SqG+i8hZZFZ12Ewd5yC/fd2hpxIxGGzLBbOz1H2uIYu+94d9H644bMyEYo2MvfP3AJuS3MPse9hu5H3PGN679LECrP6l1Dnn2GwxSezu8JT9vbjljdZWhkyQHJcwYRu5lysXmlcYeh1g2H77gckeS5ex63XedmQy0TsXXksgWlym3rcVsNDavmG+aDHUW9JVS3GWpT59Btektwg4A2Wp9xNhmaov1kgP7rqGyzeml8gyF7JIroxOgsNq3Wrs6tN9S6ynHjz7WIlK98g7Pa0HwJ2AbETYo2bVaNx9cammRzv3UYabXmYVxnyEyZf7hGvMFF6opR3CpDJssPDWKmEUos38e/xpAZ3B7gfQhuk6UDnBWG2vSgTs/7cdV/qeJyQ603/NoRMoRVC39NxGJDVDNyFE5x2V1cashciP601J8sDdSFhkzu3hgLR1j+vSCjLjQ0qHbySAQXC3590jJDxO5tAoSK50c3iwxldICRzDuEG8DNXf0SQ6b7Hx+LjiDS2f2oSwxNe8CH8IVN5060LzA09cHqxB8oMROn84ZafnrJaRUib6bjdNYQdZSJDDETp7OG+nZswedRxV2GMvupVafFTOfTOUNTHjnNDFg1tbdhxvDgaWZgOtnMGBJ0yydhYuvYtKH+Ov4d9KiJBhMzhjRNyuBYMV4wJg2/JEWndQrUeDqdNNS3w1eKAaH60RNvk4bm4MOZ/5B+j8XplCHT9C/pQYjx/oNThqYOo1R4bD9WMKYMdRVGJn3Cx8J0wpCxYO6ggzfrDWn6WVJhx2YYU4ZNUIZjRX/KkKLZIxnWfr/3mDIMZUAzwOv3YTqVS0VQhmqkXci4IUuCEoxVu9ZQ1iElGt+1Z62huT9PDIZCzO37tYwJwyrlIaHS9+O2yZF3YIxYTIza9E9f8jrWV/yTcBmGz2UYPpdh+FyG4XMZhs9lGD6XYfhchuHjDIufnpwTU0R1cm7qfwD7KpGpQu75IwAAAABJRU5ErkJggg==";
    $("#preloader").css('display', 'block');
    if (event.target.files.length > 0) {
      var validFile = this.isValidFile(event.target.files);
      if (validFile) {
        this.fileCode = false;
        if (this.user_profile_pic == "") {
          this.image_data = '';
        }
        var reader = new FileReader();

        reader.onload = (event) => {
          let picFile = <FileReader>event.target;
          this.image_data = picFile.result;

          var image = new Image();
          image.src = JSON.parse(JSON.stringify(this.image_data));

          $("#userLogo").attr('src', this.image_data);
          $("#userLogo1").attr('src', this.image_data);
          $("#preloader").css('display', 'none');
        };
        reader.readAsDataURL(files.item(0));
      } else {
        this.fileCode = false;
        this.image_data = '';
        $("#userLogo").attr('src', data);
        $("#userLogo1").attr('src', data);
        $("#preloader").css('display', 'none');
      }
    } else {
      this.fileCode = false;
      this.image_data = '';
      $("#userLogo").attr('src', data);
      $("#userLogo1").attr('src', data);
      $("#preloader").css('display', 'none');
    }
  }

  /*onChange(event,  files : FileList) {
    this.files = event.target.files;
    this.fileUpload = files.item(0).name;

    if(event.target.files.length > 0){
      var validFile = this.isValidFile(event.target.files);
      var imgData = "data:image/png;base64, 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";
      if(validFile){
        this.fileCode = false;
        this.upload();
        if(this.user_profile_pic == ""){
          this.image_data = '';
        }
      } else {
        this.image_data = '';
        this.fileCode = true;
        var data = "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";
        $("#userLogo").attr('src',"data:image/png;base64, "+ data);
      }
    } else {
      this.fileCode = false;
      this.image_data = '';
      var data = "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";
      $("#userLogo").attr('src',"data:image/png;base64, "+ data);
    }
  }*/

  isValidFile(file) {
    var supportedRegex = /(\.jpg|\.jpeg|\.jpe|\.png)$/i;
    var newSupRegex = new RegExp(supportedRegex);
    var validFileType = newSupRegex.test(this.files[0].name);
    return validFileType;
  }

  upload() {
    //locate the file element meant for the file upload.
    let inputEl: HTMLInputElement;
    inputEl = this.el.nativeElement.querySelector('#proPic');
    //get the total amount of files attached to the file input.
    let fileCount: number = inputEl.files.length;
    //create a new fromdata instance
    let formData = new FormData();
    //check if the filecount is greater than zero, to be sure a file was selected.
    if (fileCount > 0) { // a file was selected
      //append the key name 'photo' with the first file in the element
      formData.append('photo', inputEl.files.item(0));
      //call the angular http method
      $("#preloader").css('display', 'block');
      this.http
        //post the form data to the url defined above and map the response. Then subscribe //to initiate the post. if you don't subscribe, angular wont post.
        .post(Configuration.ServerWithApiUrl + '/uploadlogo', formData).map((res: Response) => res.json()).subscribe(
          //map the success function and alert the response
          (success) => {
            this.image_data = success.data;
            $("#userLogo").attr('src', "data:image/png;base64, " + success.data);
            $("#preloader").css('display', 'none');
          },
          (error) => {
            console.log(error);
            $("#preloader").css('display', 'none');
          });
    }
  }

  changeImage(proPicUser) {
    if (!this.fileCode) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      let id = currentUser.user.userid;
      var Obj = {
        user_id: id,
        profile_pic: this.image_data,
        updated_by: id
      };

      $("#preloader").css('display', 'block');
      this.userService.changeProfileImage(Obj)
        .subscribe(result => {
          this.proPicStatusCode = result.statusCode;
          if (result.success) {
            this.image_data = "";
            $('#profilePicModal').modal('hide');
            $('#profilesuccessModal').modal('show');
            this.userService.usersProfilePic(id).subscribe(res => {
              if (res.data != undefined) {
                if (res.data.profile_pic) {
                  if (res.data.profile_pic.includes('PROFPIC')) {
                    $("#profilePic").attr('src', Configuration.S3_BucketObjectURL + res.data.profile_pic);
                  } else {
                    $("#profilePic").attr('src', 'data:image/png;base64,' + res.data.profile_pic);
                  }
                  var data = "data:image/png;base64,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";
                  $("#userLogo").attr('src', data);
                  $("#preloader").css('display', 'none');
                } else {
                  $("#preloader").css('display', 'none');
                }
              } else {
                $("#preloader").css('display', 'none');
              }
            });
            proPicUser.reset();
            this.fileUpload = "Select Profile Picture";
            window.location.reload();
          } else {
            $("#preloader").css('display', 'none');
          }

        });

    }
  }

  closeSuccessModal() {
    this.proPicStatusCode = '';
    this.userUpdateStatusCode = "";
    this.pwdErrorCode = '';
    this.securityQueSuccessCode = '';
    this.passForm.reset();
    $('#profilesuccessModal').modal('hide');
  }

  closePictureModel(proPicUser) {
    proPicUser.reset();
    this.fileCode = false;
    this.image_data = "";
    var data = "data:image/png;base64,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";
    $("#userLogo").attr('src', data);
    $('#profilePicModal').modal('hide');
    this.fileUpload = "Select Profile Picture";
  }

  checkValidNumber(e) {
    let str = e.target.value.trim();
    let res: boolean = false;

    if (str) {

      let newSupRegex = new RegExp("\\.");
      let validTxt = newSupRegex.test(str);

      if (!validTxt) {

        if (!isNaN(str.replace(/[^a-zA-Z]/g, ""))) {
          if (str.length > 5 && str.length < 18) {
            try {
              const newStr: string = this.countryCode + str;
              this.parse = parse(newStr);
              // Print number in the international format.
              res = isValidNumber(this.parse);
              var num = formatNumber(newStr, 'International');
              this.User.phone = num.trim();
            } catch (error) {
              this.errorMsg = "202";
            }
          } else if (str.length == 0) {
            res = true;
          }
        }
      } else {
        this.errorMsg = "202";
      }

      if (!res) {
        this.errorMsg = "203";
      } else {
        this.errorMsg = "";
        /*if(str.length > 0){
         this.errorMsg = "";
         } else {
         this.errorMsg = "205";
         }*/
      }
    } else {
      this.errorMsg = '';
    }
  }

  updateMyData(userForm) {
    if (this.errorMsg == "") {
      const theCommunity = JSON.parse(localStorage.getItem('currentUser'));
      const updated_by = theCommunity.user.userid;
      this.User.updated_by = updated_by;

      this.userService.updateUser(this.User)
        .subscribe(result => {
          this.userUpdateStatusCode = result.statusCode;
          if (result.success) {
            this.fullname = this.User.first_name + ' ' + this.User.last_name;
            $('#updateProfileModal').modal('hide');
            userForm.reset();
            this.userUpdateStatusCode = result.statusCode;
            $('#profilesuccessModal').modal('show');
            var obj = {
              action: "change_community",
              updated_by: updated_by,
              user_id: updated_by
            };

            this.updateNotification(obj);

            // change profile pic start
            if (this.fileUpload) {
              if (!this.fileCode) {
                const currentUser = JSON.parse(localStorage.getItem('currentUser'));
                let id = currentUser.user.userid;
                var Obj = {
                  user_id: id,
                  profile_pic: this.image_data,
                  updated_by: id
                };

                $("#preloader").css('display', 'block');
                this.userService.changeProfileImage(Obj)
                  .subscribe(result => {
                    // this.proPicStatusCode = result.statusCode;
                    if (result.success) {
                      this.image_data = "";
                      $('#profilePicModal').modal('hide');
                      // $('#profilesuccessModal').modal('show');
                      this.userService.usersProfilePic(id).subscribe(res => {
                        console.log("user profile res", res.data);
                        if (res.data != undefined) {
                          if (res.data.profile_pic) {
                            if (res.data.profile_pic.includes('PROFPIC')) {
                              $("#profilePic").attr('src', Configuration.S3_BucketObjectURL + res.data.profile_pic);
                            } else {
                              $("#profilePic").attr('src', 'data:image/png;base64,' + res.data.profile_pic);
                            }
                            var data = "data:image/png;base64,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";
                            $("#userLogo1").attr('src', data);
                            $("#preloader").css('display', 'none');
                          } else {
                            $("#preloader").css('display', 'none');
                          }
                        } else {
                          $("#preloader").css('display', 'none');
                        }
                      });
                      // proPicUser.reset();
                      window.location.reload();
                      this.fileUpload = "Select Profile Picture";
                    } else {
                      $("#preloader").css('display', 'none');
                    }

                  });

              }
            }
            // change profile pic end
          }
        });
    }
  }

  closeProfileModal(userForm) {
    userForm.reset();
    this.userUpdateStatusCode = "";
    this.errorMsg = "";
    this.communityRoleList = [];
    this.business_unit = [];
    this.isDisableCommRole = false;
    this.isDisableBUnit = false;
    $('#updateProfileModal').modal('hide');
  }

  updateNotification(obj) {
    this.userService.updateNotification(obj)
      .subscribe(notification => {
        const theCommunity = JSON.parse(localStorage.getItem('currentUser'));
        this.userService.getNotification(theCommunity.user.userid).subscribe(res => {
          if (res.success) {
            this.notificationList = [];
            this.getNotificationCount = res.data.length;
            if (res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                const obj = {
                  'content': res.data[i].content,
                  'sender': res.data[i].sender,
                  'msg_id': res.data[i].msg_id,
                  'licence_user_id': res.data[i].licence_user_id
                };
                this.notificationList.push(obj);
                this.noNotification = true;
              }
            } else {
              this.noNotification = false;
            }
          }
        });
      });
  }

  gotoSubscription() {
    //this.router.navigate(['/dashboard/learner/subscribe']);
    const windowFeatures = 'width=1300,height=700,left=100,top=100,menubar=no,toolbar=no,location=no,resizable=yes,scrollbars=yes,status=yes';
    this.iframeHeight = "640";
    this.iframeWidth = "1200";
    this.coachingModalPopupHeight = "700px";
    this.coachingModalPopupWidth = "1223px";
    let url = Configuration.ManagerBaseURL + 'dashboard/learner/subscribe';
    this.openSubscriptionModal = true;
    this.subscribeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    $('#subscriptionModal').modal('show');
  }

  /* gotoLeaderBoard(){
     this.router.navigate(['/dashboard/leaderBoard']);
   }*/
   closeSubscriptionModal(){
    $('#subscriptionModal').modal('hide');
    window.location.reload();
   }
  clearForm() {
    this.licenseRenewStatusCode = "";
  }

  updateLicense() {
    this.agreement = undefined;
    this.userService.updateSubscribeLicense(this.valArr).subscribe(res => {
      this.subscribeLicIdList = res.data;
      if (this.appliedCoupons != undefined && this.appliedCoupons != 0) {
        const obj = {
          coupon_id: this.coupon_id,
          no_of_coupon_used: this.appliedCoupons
        };
        this.LicenseService.updateUsedCoupos(obj).subscribe(res => {
        });
      }
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.LicenseService.deleteExpiryMessages(this.valArr[0].licence_user_id, this.valArr[0].user_id).subscribe(res => {
        this.userService.getNotification(currentUser.user.userid).subscribe(res => {
          if (res.success) {
            this.notificationList = [];
            if (res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                const obj = {
                  'content': res.data[i].content,
                  'sender': res.data[i].sender,
                  'msg_id': res.data[i].msg_id,
                  'licence_user_id': res.data[i].licence_user_id
                };

                this.notificationList.push(obj);
                this.noNotification = true;
              }
            } else {
              this.noNotification = false;
            }
            this.getNotificationCount = res.data.length;
          }
        });
        $('#notificationSuccessModal').modal('show');
      });
    });
  }

  changePassword() {
    this.pwdErrorCode = '';
    this.passwordType = false;
    this.passForm.reset();
    $('#changePwdModal').modal('show');
  }

  closePwdModal(passForm) {
    passForm.reset();
    this.pwdErrorCode = '';
    $('#changePwdModal').modal('hide');
  }

  updatePassword(passForm) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.changePwdObj.user_id = currentUser.user.userid;
    this.changePwdObj.updated_by = currentUser.user.userid;

    let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(this.changePwdObj), '#Alignor Credentials#').toString();
    let authentication = {
      authentication: ciphertext
    };

    this.userService.updatePassword(authentication).subscribe(user => {
      this.pwdErrorCode = user.statusCode;
      if (user.success) {
        passForm.reset();
        $('#changePwdModal').modal('hide');
        $('#profilesuccessModal').modal('show');
      }
    });
  }

  clearFlag() {
    this.pwdErrorCode = '';
  }

  changeCountry(e) {
    this.User.phone = "";
    // this.contact = "";
    if (this.countryId) {
      let ind = this.countryCodeList.findIndex(c => c.iso2 == this.countryId);
      if (ind > -1) {
        this.User.country = this.countryCodeList[ind].name;
        this.countryCode = this.countryCodeList[ind].code;
      } else {
        this.User.country = undefined;
        this.countryCode = undefined;
      }
      // this.errorMsg = "205";
      this.errorMsg = "";
    } else {
      this.User.country = "";
      this.errorMsg = "";
      this.User.phone = "";
    }
  }

  follwRules() {
    if (this.User.community_id == 'global') {
      this.businessUnitList = []; // JSON.parse(JSON.stringify(this.businessUnitList));
      this.User.business_unit = 'None';
      this.isDisableBUnit = true;
    } else {
      if (this.businessUnitList && this.businessUnitList.length > 0) {
        if (this.businessUnitList.length == 1) {
          this.isDisableBUnit = true;
          this.User.business_unit = this.businessUnitList[0];
        } else {
          this.isDisableBUnit = false;
        }
      } else {
        this.User.business_unit = 'None';
        this.isDisableBUnit = true;
      }
    }

    if (this.communityRoleList && this.communityRoleList.length > 0) {
      //For CommRole
      if (this.communityRoleList.length == 1) {
        this.isDisableCommRole = true;
        this.User.comm_role = this.communityRoleList[0];
      } else {
        this.isDisableCommRole = false;
      }
    } else {
      this.User.comm_role = 'None';
      this.isDisableCommRole = true;
    }
  }
  getAllRoleBUnit() {
    this.userService.getRoleAndBusinessUnitById(this.User.community_id).subscribe(rb => {
      if (rb.success) {
        if (rb.data && rb.data.length > 0) {
          let resArr = rb.data;
          let ind = resArr.findIndex(r => r.comm_id == 'global');
          if (ind > -1) {
            this.globalCommRoleList = resArr[ind].comm_role && resArr[ind].comm_role.length > 0 ? resArr[ind].comm_role : [];
            this.globalBUnitList = resArr[ind].business_unit && resArr[ind].business_unit.length > 0 ? resArr[ind].business_unit : [];
            resArr.splice(ind, 1);
            if (resArr && resArr.length > 0) {
              this.communityRoleList = resArr[0].comm_role && resArr[0].comm_role.length > 0 ? resArr[0].comm_role : this.globalCommRoleList;
              this.businessUnitList = resArr[0].business_unit && resArr[0].business_unit.length > 0 ? resArr[0].business_unit : [];
            } else {
              this.communityRoleList = (this.globalCommRoleList && this.globalCommRoleList.length > 0) ? JSON.parse(JSON.stringify(this.globalCommRoleList)) : [];
              this.businessUnitList = []; // JSON.parse(JSON.stringify(this.globalBUnitList));
            }
          } else {
            this.globalCommRoleList = [];
            this.globalBUnitList = [];
            let cind = resArr.findIndex(r => r.comm_id == this.User.community_id);
            if (cind > -1) {
              this.communityRoleList = resArr[cind].comm_role && resArr[cind].comm_role.length > 0 ? resArr[cind].comm_role : [];
              this.businessUnitList = resArr[cind].business_unit && resArr[cind].business_unit.length > 0 ? resArr[cind].business_unit : [];
            } else {
              this.communityRoleList = [];
              this.businessUnitList = [];
            }
          }
          this.follwRules();
        }

      }
    });
  }

  getCommunityResources(id) {
    if (id && id.length > 0) {
      this.userService.getResourceConfiguration(id).subscribe(res => {
        if (res.success) {
          let commResObj = {
            community_id: res.data.comm_id,
            community_name: res.data.comm_name,
            resource_config: res.data.resource_config
          };
          localStorage.setItem('CommResources', JSON.stringify(commResObj));

          let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
          let lang_id = localStorage.getItem('defaultLangId') ? localStorage.getItem('defaultLangId') : 'English';

          this.translate.reloadLang(lang_name);
        }
      });
    }
  }

  displayMenuNav() {
    if ($('.sideMenunav').hasClass('displayMenu')) {
      $('.sideMenunav').removeClass('displayMenu');
      this.GlobalService.changeMessage(false);
    } else {
      $('.sideMenunav').addClass('displayMenu');
      $('.asideRightLearnerDashboard').removeClass('asideRightLearnerDashboardOpen');
      this.GlobalService.changeMessage(true); 
    }
  }


  getSupportQuestions() {
    this.userService.getSupportQue().subscribe(
      res => {
        if (res.success) {
          this.supportQueData = res.data;
        }
      }
    )
  }

  openSupportModal() {
    this.suportSuccessMsg = false;
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.supportObj.question = '';
    this.supportObj.answer = '';
    this.supportObj.user_id = currentUser.user.userid;
    this.supportObj.comm_id = currentUser.user.community_id;
    this.supportObj.username = currentUser.user.username;
    this.supportObj.fullname = currentUser.user.fullname;
    this.getSupportQuestions();
    $('#supportFormModal').modal();
  }

  closeSupportModal(supportForm) {
    supportForm.reset();
    $('#supportFormModal').modal('hide');
  }

  supportFormSubmit(supportForm) {
    this.suportSuccessMsg = false;
    this.userService.sendSupportInquiry(this.supportObj).subscribe(res => {
      if (res.success) {
        this.suportSuccessMsg = true;
        // setTimeout(() => {
        //   this.suportSuccessMsg = false;
        // }, 2000);
        supportForm.reset();
        $('#supportFormModal').modal('hide');
        $('#successSupportModal').modal();
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.supportObj.question = '';
        this.supportObj.answer = '';
        this.supportObj.user_id = currentUser.user.userid;
        this.supportObj.comm_id = currentUser.user.community_id;
        this.supportObj.username = currentUser.user.username;
        this.supportObj.fullname = currentUser.user.fullname;
      }
    });
  }

  closeSuccessSupportModal() {
    $('#successSupportModal').modal('hide');
    this.suportSuccessMsg = false;
  }

  changePasswordType(type) {

    if (type == 'old') {
      this.passwordType = !this.passwordType;
    } else if (type == 'new') {
      this.passwordNewType = !this.passwordNewType;
    } else if (type == 'confirm') {
      this.passwordConfirmType = !this.passwordConfirmType;
    }

  }

  // update security question
  callSecurityQuePopup() {
    $('#changeSecurityQueModal').modal('show');
    let lang_id = this.GlobalService.getLangId();
    this.userService.getSecurityQuestions(lang_id)
      .subscribe(questions => {
        if (questions.success) {
          this.securityQuestions = questions.data;
          this.answer = '';
          $("#preloader").css('display', 'none');
        }
      });

    this.userService.getSecurityQuestionNAnswerPopup(this.userId)
      .subscribe(questions => {
        if (questions.success) {
          //  this.question = questions.data.question;
          //  this.answer = questions.data.answer;
          //  $('#changeSecurityQueModal').modal('hide');
        }
      });
  }

  closeSecurityQueModal() {
    $('#changeSecurityQueModal').modal('hide');
  }

  updateSecurityQue(form) {
    let question = form.value.que;
    if (form.valid) {
      this.securityQuestions.forEach(que => {
        if (question == que.que) {
          this.que_id = que.que_id;
          const obj = {
            question_id: this.que_id,
            answer: form.value.ans,
            question: form.value.que
          }
          this.userService.changeSecurityQuestionNAnswer(this.userId, obj)
            .subscribe(res => {
              this.securityQueSuccessCode = res.statusCode;
              $('#changeSecurityQueModal').modal('hide');
              $('#profilesuccessModal').modal('show');
            });
        }
      })

    } else {
      console.log("enter valid values");
    }


  }

  changeSecurityQue(ev: any) {
    // console.log(ev.target.value);
  }

  closeSecurityQuePopupModal(secquestionForm) {
    secquestionForm.reset();
    this.securityQueSuccessCode = '';
    $('#changeSecurityQueModal').modal('hide');
  }
  openProgressAndCompletion(){
    window.addEventListener('message', function (event) {
      if (event.data === 'closeLearnerIframe') {
        $('#coachingModal1').modal('hide');
      }
    });

    const windowFeatures = 'width=1300,height=700,left=100,top=100,menubar=no,toolbar=no,location=no,resizable=yes,scrollbars=yes,status=yes';
    this.iframeHeight = "640";
    this.iframeWidth = "1200";
    this.coachingModalPopupHeight = "700px";
    this.coachingModalPopupWidth = "1223px";
    const defaultLangId = localStorage.getItem('defaultLangId');
    const theUser = JSON.parse(localStorage.getItem('currentUser'));
    let url = Configuration.LearnerDashboardBaseURL + '?user_id=' + this.userId + '&community_id=' + this.community_id + '&component_to_load=progressAndCompletion' +
          '&language=' + theUser.user.defaultLang + '&defaultLangId=' + defaultLangId;
    this.coachUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    $('#coachingModal1').modal('show');
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/header/header.component.ts